import { isa as __isa } from "@aws-sdk/smithy-client";
export var ADMChannelRequest;
(function (ADMChannelRequest) {
    function isa(o) {
        return __isa(o, "ADMChannelRequest");
    }
    ADMChannelRequest.isa = isa;
})(ADMChannelRequest || (ADMChannelRequest = {}));
export var ADMChannelResponse;
(function (ADMChannelResponse) {
    function isa(o) {
        return __isa(o, "ADMChannelResponse");
    }
    ADMChannelResponse.isa = isa;
})(ADMChannelResponse || (ADMChannelResponse = {}));
export var ADMMessage;
(function (ADMMessage) {
    function isa(o) {
        return __isa(o, "ADMMessage");
    }
    ADMMessage.isa = isa;
})(ADMMessage || (ADMMessage = {}));
export var APNSChannelRequest;
(function (APNSChannelRequest) {
    function isa(o) {
        return __isa(o, "APNSChannelRequest");
    }
    APNSChannelRequest.isa = isa;
})(APNSChannelRequest || (APNSChannelRequest = {}));
export var APNSChannelResponse;
(function (APNSChannelResponse) {
    function isa(o) {
        return __isa(o, "APNSChannelResponse");
    }
    APNSChannelResponse.isa = isa;
})(APNSChannelResponse || (APNSChannelResponse = {}));
export var APNSMessage;
(function (APNSMessage) {
    function isa(o) {
        return __isa(o, "APNSMessage");
    }
    APNSMessage.isa = isa;
})(APNSMessage || (APNSMessage = {}));
export var APNSPushNotificationTemplate;
(function (APNSPushNotificationTemplate) {
    function isa(o) {
        return __isa(o, "APNSPushNotificationTemplate");
    }
    APNSPushNotificationTemplate.isa = isa;
})(APNSPushNotificationTemplate || (APNSPushNotificationTemplate = {}));
export var APNSSandboxChannelRequest;
(function (APNSSandboxChannelRequest) {
    function isa(o) {
        return __isa(o, "APNSSandboxChannelRequest");
    }
    APNSSandboxChannelRequest.isa = isa;
})(APNSSandboxChannelRequest || (APNSSandboxChannelRequest = {}));
export var APNSSandboxChannelResponse;
(function (APNSSandboxChannelResponse) {
    function isa(o) {
        return __isa(o, "APNSSandboxChannelResponse");
    }
    APNSSandboxChannelResponse.isa = isa;
})(APNSSandboxChannelResponse || (APNSSandboxChannelResponse = {}));
export var APNSVoipChannelRequest;
(function (APNSVoipChannelRequest) {
    function isa(o) {
        return __isa(o, "APNSVoipChannelRequest");
    }
    APNSVoipChannelRequest.isa = isa;
})(APNSVoipChannelRequest || (APNSVoipChannelRequest = {}));
export var APNSVoipChannelResponse;
(function (APNSVoipChannelResponse) {
    function isa(o) {
        return __isa(o, "APNSVoipChannelResponse");
    }
    APNSVoipChannelResponse.isa = isa;
})(APNSVoipChannelResponse || (APNSVoipChannelResponse = {}));
export var APNSVoipSandboxChannelRequest;
(function (APNSVoipSandboxChannelRequest) {
    function isa(o) {
        return __isa(o, "APNSVoipSandboxChannelRequest");
    }
    APNSVoipSandboxChannelRequest.isa = isa;
})(APNSVoipSandboxChannelRequest || (APNSVoipSandboxChannelRequest = {}));
export var APNSVoipSandboxChannelResponse;
(function (APNSVoipSandboxChannelResponse) {
    function isa(o) {
        return __isa(o, "APNSVoipSandboxChannelResponse");
    }
    APNSVoipSandboxChannelResponse.isa = isa;
})(APNSVoipSandboxChannelResponse || (APNSVoipSandboxChannelResponse = {}));
export var Action;
(function (Action) {
    Action["DEEP_LINK"] = "DEEP_LINK";
    Action["OPEN_APP"] = "OPEN_APP";
    Action["URL"] = "URL";
})(Action || (Action = {}));
export var ActivitiesResponse;
(function (ActivitiesResponse) {
    function isa(o) {
        return __isa(o, "ActivitiesResponse");
    }
    ActivitiesResponse.isa = isa;
})(ActivitiesResponse || (ActivitiesResponse = {}));
export var Activity;
(function (Activity) {
    function isa(o) {
        return __isa(o, "Activity");
    }
    Activity.isa = isa;
})(Activity || (Activity = {}));
export var ActivityResponse;
(function (ActivityResponse) {
    function isa(o) {
        return __isa(o, "ActivityResponse");
    }
    ActivityResponse.isa = isa;
})(ActivityResponse || (ActivityResponse = {}));
export var AddressConfiguration;
(function (AddressConfiguration) {
    function isa(o) {
        return __isa(o, "AddressConfiguration");
    }
    AddressConfiguration.isa = isa;
})(AddressConfiguration || (AddressConfiguration = {}));
export var AndroidPushNotificationTemplate;
(function (AndroidPushNotificationTemplate) {
    function isa(o) {
        return __isa(o, "AndroidPushNotificationTemplate");
    }
    AndroidPushNotificationTemplate.isa = isa;
})(AndroidPushNotificationTemplate || (AndroidPushNotificationTemplate = {}));
export var ApplicationDateRangeKpiResponse;
(function (ApplicationDateRangeKpiResponse) {
    function isa(o) {
        return __isa(o, "ApplicationDateRangeKpiResponse");
    }
    ApplicationDateRangeKpiResponse.isa = isa;
})(ApplicationDateRangeKpiResponse || (ApplicationDateRangeKpiResponse = {}));
export var ApplicationResponse;
(function (ApplicationResponse) {
    function isa(o) {
        return __isa(o, "ApplicationResponse");
    }
    ApplicationResponse.isa = isa;
})(ApplicationResponse || (ApplicationResponse = {}));
export var ApplicationSettingsResource;
(function (ApplicationSettingsResource) {
    function isa(o) {
        return __isa(o, "ApplicationSettingsResource");
    }
    ApplicationSettingsResource.isa = isa;
})(ApplicationSettingsResource || (ApplicationSettingsResource = {}));
export var ApplicationsResponse;
(function (ApplicationsResponse) {
    function isa(o) {
        return __isa(o, "ApplicationsResponse");
    }
    ApplicationsResponse.isa = isa;
})(ApplicationsResponse || (ApplicationsResponse = {}));
export var AttributeDimension;
(function (AttributeDimension) {
    function isa(o) {
        return __isa(o, "AttributeDimension");
    }
    AttributeDimension.isa = isa;
})(AttributeDimension || (AttributeDimension = {}));
export var AttributeType;
(function (AttributeType) {
    AttributeType["EXCLUSIVE"] = "EXCLUSIVE";
    AttributeType["INCLUSIVE"] = "INCLUSIVE";
})(AttributeType || (AttributeType = {}));
export var AttributesResource;
(function (AttributesResource) {
    function isa(o) {
        return __isa(o, "AttributesResource");
    }
    AttributesResource.isa = isa;
})(AttributesResource || (AttributesResource = {}));
export var BadRequestException;
(function (BadRequestException) {
    function isa(o) {
        return __isa(o, "BadRequestException");
    }
    BadRequestException.isa = isa;
})(BadRequestException || (BadRequestException = {}));
export var BaiduChannelRequest;
(function (BaiduChannelRequest) {
    function isa(o) {
        return __isa(o, "BaiduChannelRequest");
    }
    BaiduChannelRequest.isa = isa;
})(BaiduChannelRequest || (BaiduChannelRequest = {}));
export var BaiduChannelResponse;
(function (BaiduChannelResponse) {
    function isa(o) {
        return __isa(o, "BaiduChannelResponse");
    }
    BaiduChannelResponse.isa = isa;
})(BaiduChannelResponse || (BaiduChannelResponse = {}));
export var BaiduMessage;
(function (BaiduMessage) {
    function isa(o) {
        return __isa(o, "BaiduMessage");
    }
    BaiduMessage.isa = isa;
})(BaiduMessage || (BaiduMessage = {}));
export var BaseKpiResult;
(function (BaseKpiResult) {
    function isa(o) {
        return __isa(o, "BaseKpiResult");
    }
    BaseKpiResult.isa = isa;
})(BaseKpiResult || (BaseKpiResult = {}));
export var CampaignDateRangeKpiResponse;
(function (CampaignDateRangeKpiResponse) {
    function isa(o) {
        return __isa(o, "CampaignDateRangeKpiResponse");
    }
    CampaignDateRangeKpiResponse.isa = isa;
})(CampaignDateRangeKpiResponse || (CampaignDateRangeKpiResponse = {}));
export var CampaignEmailMessage;
(function (CampaignEmailMessage) {
    function isa(o) {
        return __isa(o, "CampaignEmailMessage");
    }
    CampaignEmailMessage.isa = isa;
})(CampaignEmailMessage || (CampaignEmailMessage = {}));
export var CampaignEventFilter;
(function (CampaignEventFilter) {
    function isa(o) {
        return __isa(o, "CampaignEventFilter");
    }
    CampaignEventFilter.isa = isa;
})(CampaignEventFilter || (CampaignEventFilter = {}));
export var CampaignHook;
(function (CampaignHook) {
    function isa(o) {
        return __isa(o, "CampaignHook");
    }
    CampaignHook.isa = isa;
})(CampaignHook || (CampaignHook = {}));
export var CampaignLimits;
(function (CampaignLimits) {
    function isa(o) {
        return __isa(o, "CampaignLimits");
    }
    CampaignLimits.isa = isa;
})(CampaignLimits || (CampaignLimits = {}));
export var CampaignResponse;
(function (CampaignResponse) {
    function isa(o) {
        return __isa(o, "CampaignResponse");
    }
    CampaignResponse.isa = isa;
})(CampaignResponse || (CampaignResponse = {}));
export var CampaignSmsMessage;
(function (CampaignSmsMessage) {
    function isa(o) {
        return __isa(o, "CampaignSmsMessage");
    }
    CampaignSmsMessage.isa = isa;
})(CampaignSmsMessage || (CampaignSmsMessage = {}));
export var CampaignState;
(function (CampaignState) {
    function isa(o) {
        return __isa(o, "CampaignState");
    }
    CampaignState.isa = isa;
})(CampaignState || (CampaignState = {}));
export var CampaignStatus;
(function (CampaignStatus) {
    CampaignStatus["COMPLETED"] = "COMPLETED";
    CampaignStatus["DELETED"] = "DELETED";
    CampaignStatus["EXECUTING"] = "EXECUTING";
    CampaignStatus["PAUSED"] = "PAUSED";
    CampaignStatus["PENDING_NEXT_RUN"] = "PENDING_NEXT_RUN";
    CampaignStatus["SCHEDULED"] = "SCHEDULED";
})(CampaignStatus || (CampaignStatus = {}));
export var CampaignsResponse;
(function (CampaignsResponse) {
    function isa(o) {
        return __isa(o, "CampaignsResponse");
    }
    CampaignsResponse.isa = isa;
})(CampaignsResponse || (CampaignsResponse = {}));
export var ChannelResponse;
(function (ChannelResponse) {
    function isa(o) {
        return __isa(o, "ChannelResponse");
    }
    ChannelResponse.isa = isa;
})(ChannelResponse || (ChannelResponse = {}));
export var ChannelType;
(function (ChannelType) {
    ChannelType["ADM"] = "ADM";
    ChannelType["APNS"] = "APNS";
    ChannelType["APNS_SANDBOX"] = "APNS_SANDBOX";
    ChannelType["APNS_VOIP"] = "APNS_VOIP";
    ChannelType["APNS_VOIP_SANDBOX"] = "APNS_VOIP_SANDBOX";
    ChannelType["BAIDU"] = "BAIDU";
    ChannelType["CUSTOM"] = "CUSTOM";
    ChannelType["EMAIL"] = "EMAIL";
    ChannelType["GCM"] = "GCM";
    ChannelType["SMS"] = "SMS";
    ChannelType["VOICE"] = "VOICE";
})(ChannelType || (ChannelType = {}));
export var ChannelsResponse;
(function (ChannelsResponse) {
    function isa(o) {
        return __isa(o, "ChannelsResponse");
    }
    ChannelsResponse.isa = isa;
})(ChannelsResponse || (ChannelsResponse = {}));
export var Condition;
(function (Condition) {
    function isa(o) {
        return __isa(o, "Condition");
    }
    Condition.isa = isa;
})(Condition || (Condition = {}));
export var ConditionalSplitActivity;
(function (ConditionalSplitActivity) {
    function isa(o) {
        return __isa(o, "ConditionalSplitActivity");
    }
    ConditionalSplitActivity.isa = isa;
})(ConditionalSplitActivity || (ConditionalSplitActivity = {}));
export var CreateAppRequest;
(function (CreateAppRequest) {
    function isa(o) {
        return __isa(o, "CreateAppRequest");
    }
    CreateAppRequest.isa = isa;
})(CreateAppRequest || (CreateAppRequest = {}));
export var CreateAppResponse;
(function (CreateAppResponse) {
    function isa(o) {
        return __isa(o, "CreateAppResponse");
    }
    CreateAppResponse.isa = isa;
})(CreateAppResponse || (CreateAppResponse = {}));
export var CreateApplicationRequest;
(function (CreateApplicationRequest) {
    function isa(o) {
        return __isa(o, "CreateApplicationRequest");
    }
    CreateApplicationRequest.isa = isa;
})(CreateApplicationRequest || (CreateApplicationRequest = {}));
export var CreateCampaignRequest;
(function (CreateCampaignRequest) {
    function isa(o) {
        return __isa(o, "CreateCampaignRequest");
    }
    CreateCampaignRequest.isa = isa;
})(CreateCampaignRequest || (CreateCampaignRequest = {}));
export var CreateCampaignResponse;
(function (CreateCampaignResponse) {
    function isa(o) {
        return __isa(o, "CreateCampaignResponse");
    }
    CreateCampaignResponse.isa = isa;
})(CreateCampaignResponse || (CreateCampaignResponse = {}));
export var CreateEmailTemplateRequest;
(function (CreateEmailTemplateRequest) {
    function isa(o) {
        return __isa(o, "CreateEmailTemplateRequest");
    }
    CreateEmailTemplateRequest.isa = isa;
})(CreateEmailTemplateRequest || (CreateEmailTemplateRequest = {}));
export var CreateEmailTemplateResponse;
(function (CreateEmailTemplateResponse) {
    function isa(o) {
        return __isa(o, "CreateEmailTemplateResponse");
    }
    CreateEmailTemplateResponse.isa = isa;
})(CreateEmailTemplateResponse || (CreateEmailTemplateResponse = {}));
export var CreateExportJobRequest;
(function (CreateExportJobRequest) {
    function isa(o) {
        return __isa(o, "CreateExportJobRequest");
    }
    CreateExportJobRequest.isa = isa;
})(CreateExportJobRequest || (CreateExportJobRequest = {}));
export var CreateExportJobResponse;
(function (CreateExportJobResponse) {
    function isa(o) {
        return __isa(o, "CreateExportJobResponse");
    }
    CreateExportJobResponse.isa = isa;
})(CreateExportJobResponse || (CreateExportJobResponse = {}));
export var CreateImportJobRequest;
(function (CreateImportJobRequest) {
    function isa(o) {
        return __isa(o, "CreateImportJobRequest");
    }
    CreateImportJobRequest.isa = isa;
})(CreateImportJobRequest || (CreateImportJobRequest = {}));
export var CreateImportJobResponse;
(function (CreateImportJobResponse) {
    function isa(o) {
        return __isa(o, "CreateImportJobResponse");
    }
    CreateImportJobResponse.isa = isa;
})(CreateImportJobResponse || (CreateImportJobResponse = {}));
export var CreateJourneyRequest;
(function (CreateJourneyRequest) {
    function isa(o) {
        return __isa(o, "CreateJourneyRequest");
    }
    CreateJourneyRequest.isa = isa;
})(CreateJourneyRequest || (CreateJourneyRequest = {}));
export var CreateJourneyResponse;
(function (CreateJourneyResponse) {
    function isa(o) {
        return __isa(o, "CreateJourneyResponse");
    }
    CreateJourneyResponse.isa = isa;
})(CreateJourneyResponse || (CreateJourneyResponse = {}));
export var CreatePushTemplateRequest;
(function (CreatePushTemplateRequest) {
    function isa(o) {
        return __isa(o, "CreatePushTemplateRequest");
    }
    CreatePushTemplateRequest.isa = isa;
})(CreatePushTemplateRequest || (CreatePushTemplateRequest = {}));
export var CreatePushTemplateResponse;
(function (CreatePushTemplateResponse) {
    function isa(o) {
        return __isa(o, "CreatePushTemplateResponse");
    }
    CreatePushTemplateResponse.isa = isa;
})(CreatePushTemplateResponse || (CreatePushTemplateResponse = {}));
export var CreateSegmentRequest;
(function (CreateSegmentRequest) {
    function isa(o) {
        return __isa(o, "CreateSegmentRequest");
    }
    CreateSegmentRequest.isa = isa;
})(CreateSegmentRequest || (CreateSegmentRequest = {}));
export var CreateSegmentResponse;
(function (CreateSegmentResponse) {
    function isa(o) {
        return __isa(o, "CreateSegmentResponse");
    }
    CreateSegmentResponse.isa = isa;
})(CreateSegmentResponse || (CreateSegmentResponse = {}));
export var CreateSmsTemplateRequest;
(function (CreateSmsTemplateRequest) {
    function isa(o) {
        return __isa(o, "CreateSmsTemplateRequest");
    }
    CreateSmsTemplateRequest.isa = isa;
})(CreateSmsTemplateRequest || (CreateSmsTemplateRequest = {}));
export var CreateSmsTemplateResponse;
(function (CreateSmsTemplateResponse) {
    function isa(o) {
        return __isa(o, "CreateSmsTemplateResponse");
    }
    CreateSmsTemplateResponse.isa = isa;
})(CreateSmsTemplateResponse || (CreateSmsTemplateResponse = {}));
export var CreateTemplateMessageBody;
(function (CreateTemplateMessageBody) {
    function isa(o) {
        return __isa(o, "CreateTemplateMessageBody");
    }
    CreateTemplateMessageBody.isa = isa;
})(CreateTemplateMessageBody || (CreateTemplateMessageBody = {}));
export var CreateVoiceTemplateRequest;
(function (CreateVoiceTemplateRequest) {
    function isa(o) {
        return __isa(o, "CreateVoiceTemplateRequest");
    }
    CreateVoiceTemplateRequest.isa = isa;
})(CreateVoiceTemplateRequest || (CreateVoiceTemplateRequest = {}));
export var CreateVoiceTemplateResponse;
(function (CreateVoiceTemplateResponse) {
    function isa(o) {
        return __isa(o, "CreateVoiceTemplateResponse");
    }
    CreateVoiceTemplateResponse.isa = isa;
})(CreateVoiceTemplateResponse || (CreateVoiceTemplateResponse = {}));
export var DefaultMessage;
(function (DefaultMessage) {
    function isa(o) {
        return __isa(o, "DefaultMessage");
    }
    DefaultMessage.isa = isa;
})(DefaultMessage || (DefaultMessage = {}));
export var DefaultPushNotificationMessage;
(function (DefaultPushNotificationMessage) {
    function isa(o) {
        return __isa(o, "DefaultPushNotificationMessage");
    }
    DefaultPushNotificationMessage.isa = isa;
})(DefaultPushNotificationMessage || (DefaultPushNotificationMessage = {}));
export var DefaultPushNotificationTemplate;
(function (DefaultPushNotificationTemplate) {
    function isa(o) {
        return __isa(o, "DefaultPushNotificationTemplate");
    }
    DefaultPushNotificationTemplate.isa = isa;
})(DefaultPushNotificationTemplate || (DefaultPushNotificationTemplate = {}));
export var DeleteAdmChannelRequest;
(function (DeleteAdmChannelRequest) {
    function isa(o) {
        return __isa(o, "DeleteAdmChannelRequest");
    }
    DeleteAdmChannelRequest.isa = isa;
})(DeleteAdmChannelRequest || (DeleteAdmChannelRequest = {}));
export var DeleteAdmChannelResponse;
(function (DeleteAdmChannelResponse) {
    function isa(o) {
        return __isa(o, "DeleteAdmChannelResponse");
    }
    DeleteAdmChannelResponse.isa = isa;
})(DeleteAdmChannelResponse || (DeleteAdmChannelResponse = {}));
export var DeleteApnsChannelRequest;
(function (DeleteApnsChannelRequest) {
    function isa(o) {
        return __isa(o, "DeleteApnsChannelRequest");
    }
    DeleteApnsChannelRequest.isa = isa;
})(DeleteApnsChannelRequest || (DeleteApnsChannelRequest = {}));
export var DeleteApnsChannelResponse;
(function (DeleteApnsChannelResponse) {
    function isa(o) {
        return __isa(o, "DeleteApnsChannelResponse");
    }
    DeleteApnsChannelResponse.isa = isa;
})(DeleteApnsChannelResponse || (DeleteApnsChannelResponse = {}));
export var DeleteApnsSandboxChannelRequest;
(function (DeleteApnsSandboxChannelRequest) {
    function isa(o) {
        return __isa(o, "DeleteApnsSandboxChannelRequest");
    }
    DeleteApnsSandboxChannelRequest.isa = isa;
})(DeleteApnsSandboxChannelRequest || (DeleteApnsSandboxChannelRequest = {}));
export var DeleteApnsSandboxChannelResponse;
(function (DeleteApnsSandboxChannelResponse) {
    function isa(o) {
        return __isa(o, "DeleteApnsSandboxChannelResponse");
    }
    DeleteApnsSandboxChannelResponse.isa = isa;
})(DeleteApnsSandboxChannelResponse || (DeleteApnsSandboxChannelResponse = {}));
export var DeleteApnsVoipChannelRequest;
(function (DeleteApnsVoipChannelRequest) {
    function isa(o) {
        return __isa(o, "DeleteApnsVoipChannelRequest");
    }
    DeleteApnsVoipChannelRequest.isa = isa;
})(DeleteApnsVoipChannelRequest || (DeleteApnsVoipChannelRequest = {}));
export var DeleteApnsVoipChannelResponse;
(function (DeleteApnsVoipChannelResponse) {
    function isa(o) {
        return __isa(o, "DeleteApnsVoipChannelResponse");
    }
    DeleteApnsVoipChannelResponse.isa = isa;
})(DeleteApnsVoipChannelResponse || (DeleteApnsVoipChannelResponse = {}));
export var DeleteApnsVoipSandboxChannelRequest;
(function (DeleteApnsVoipSandboxChannelRequest) {
    function isa(o) {
        return __isa(o, "DeleteApnsVoipSandboxChannelRequest");
    }
    DeleteApnsVoipSandboxChannelRequest.isa = isa;
})(DeleteApnsVoipSandboxChannelRequest || (DeleteApnsVoipSandboxChannelRequest = {}));
export var DeleteApnsVoipSandboxChannelResponse;
(function (DeleteApnsVoipSandboxChannelResponse) {
    function isa(o) {
        return __isa(o, "DeleteApnsVoipSandboxChannelResponse");
    }
    DeleteApnsVoipSandboxChannelResponse.isa = isa;
})(DeleteApnsVoipSandboxChannelResponse || (DeleteApnsVoipSandboxChannelResponse = {}));
export var DeleteAppRequest;
(function (DeleteAppRequest) {
    function isa(o) {
        return __isa(o, "DeleteAppRequest");
    }
    DeleteAppRequest.isa = isa;
})(DeleteAppRequest || (DeleteAppRequest = {}));
export var DeleteAppResponse;
(function (DeleteAppResponse) {
    function isa(o) {
        return __isa(o, "DeleteAppResponse");
    }
    DeleteAppResponse.isa = isa;
})(DeleteAppResponse || (DeleteAppResponse = {}));
export var DeleteBaiduChannelRequest;
(function (DeleteBaiduChannelRequest) {
    function isa(o) {
        return __isa(o, "DeleteBaiduChannelRequest");
    }
    DeleteBaiduChannelRequest.isa = isa;
})(DeleteBaiduChannelRequest || (DeleteBaiduChannelRequest = {}));
export var DeleteBaiduChannelResponse;
(function (DeleteBaiduChannelResponse) {
    function isa(o) {
        return __isa(o, "DeleteBaiduChannelResponse");
    }
    DeleteBaiduChannelResponse.isa = isa;
})(DeleteBaiduChannelResponse || (DeleteBaiduChannelResponse = {}));
export var DeleteCampaignRequest;
(function (DeleteCampaignRequest) {
    function isa(o) {
        return __isa(o, "DeleteCampaignRequest");
    }
    DeleteCampaignRequest.isa = isa;
})(DeleteCampaignRequest || (DeleteCampaignRequest = {}));
export var DeleteCampaignResponse;
(function (DeleteCampaignResponse) {
    function isa(o) {
        return __isa(o, "DeleteCampaignResponse");
    }
    DeleteCampaignResponse.isa = isa;
})(DeleteCampaignResponse || (DeleteCampaignResponse = {}));
export var DeleteEmailChannelRequest;
(function (DeleteEmailChannelRequest) {
    function isa(o) {
        return __isa(o, "DeleteEmailChannelRequest");
    }
    DeleteEmailChannelRequest.isa = isa;
})(DeleteEmailChannelRequest || (DeleteEmailChannelRequest = {}));
export var DeleteEmailChannelResponse;
(function (DeleteEmailChannelResponse) {
    function isa(o) {
        return __isa(o, "DeleteEmailChannelResponse");
    }
    DeleteEmailChannelResponse.isa = isa;
})(DeleteEmailChannelResponse || (DeleteEmailChannelResponse = {}));
export var DeleteEmailTemplateRequest;
(function (DeleteEmailTemplateRequest) {
    function isa(o) {
        return __isa(o, "DeleteEmailTemplateRequest");
    }
    DeleteEmailTemplateRequest.isa = isa;
})(DeleteEmailTemplateRequest || (DeleteEmailTemplateRequest = {}));
export var DeleteEmailTemplateResponse;
(function (DeleteEmailTemplateResponse) {
    function isa(o) {
        return __isa(o, "DeleteEmailTemplateResponse");
    }
    DeleteEmailTemplateResponse.isa = isa;
})(DeleteEmailTemplateResponse || (DeleteEmailTemplateResponse = {}));
export var DeleteEndpointRequest;
(function (DeleteEndpointRequest) {
    function isa(o) {
        return __isa(o, "DeleteEndpointRequest");
    }
    DeleteEndpointRequest.isa = isa;
})(DeleteEndpointRequest || (DeleteEndpointRequest = {}));
export var DeleteEndpointResponse;
(function (DeleteEndpointResponse) {
    function isa(o) {
        return __isa(o, "DeleteEndpointResponse");
    }
    DeleteEndpointResponse.isa = isa;
})(DeleteEndpointResponse || (DeleteEndpointResponse = {}));
export var DeleteEventStreamRequest;
(function (DeleteEventStreamRequest) {
    function isa(o) {
        return __isa(o, "DeleteEventStreamRequest");
    }
    DeleteEventStreamRequest.isa = isa;
})(DeleteEventStreamRequest || (DeleteEventStreamRequest = {}));
export var DeleteEventStreamResponse;
(function (DeleteEventStreamResponse) {
    function isa(o) {
        return __isa(o, "DeleteEventStreamResponse");
    }
    DeleteEventStreamResponse.isa = isa;
})(DeleteEventStreamResponse || (DeleteEventStreamResponse = {}));
export var DeleteGcmChannelRequest;
(function (DeleteGcmChannelRequest) {
    function isa(o) {
        return __isa(o, "DeleteGcmChannelRequest");
    }
    DeleteGcmChannelRequest.isa = isa;
})(DeleteGcmChannelRequest || (DeleteGcmChannelRequest = {}));
export var DeleteGcmChannelResponse;
(function (DeleteGcmChannelResponse) {
    function isa(o) {
        return __isa(o, "DeleteGcmChannelResponse");
    }
    DeleteGcmChannelResponse.isa = isa;
})(DeleteGcmChannelResponse || (DeleteGcmChannelResponse = {}));
export var DeleteJourneyRequest;
(function (DeleteJourneyRequest) {
    function isa(o) {
        return __isa(o, "DeleteJourneyRequest");
    }
    DeleteJourneyRequest.isa = isa;
})(DeleteJourneyRequest || (DeleteJourneyRequest = {}));
export var DeleteJourneyResponse;
(function (DeleteJourneyResponse) {
    function isa(o) {
        return __isa(o, "DeleteJourneyResponse");
    }
    DeleteJourneyResponse.isa = isa;
})(DeleteJourneyResponse || (DeleteJourneyResponse = {}));
export var DeletePushTemplateRequest;
(function (DeletePushTemplateRequest) {
    function isa(o) {
        return __isa(o, "DeletePushTemplateRequest");
    }
    DeletePushTemplateRequest.isa = isa;
})(DeletePushTemplateRequest || (DeletePushTemplateRequest = {}));
export var DeletePushTemplateResponse;
(function (DeletePushTemplateResponse) {
    function isa(o) {
        return __isa(o, "DeletePushTemplateResponse");
    }
    DeletePushTemplateResponse.isa = isa;
})(DeletePushTemplateResponse || (DeletePushTemplateResponse = {}));
export var DeleteSegmentRequest;
(function (DeleteSegmentRequest) {
    function isa(o) {
        return __isa(o, "DeleteSegmentRequest");
    }
    DeleteSegmentRequest.isa = isa;
})(DeleteSegmentRequest || (DeleteSegmentRequest = {}));
export var DeleteSegmentResponse;
(function (DeleteSegmentResponse) {
    function isa(o) {
        return __isa(o, "DeleteSegmentResponse");
    }
    DeleteSegmentResponse.isa = isa;
})(DeleteSegmentResponse || (DeleteSegmentResponse = {}));
export var DeleteSmsChannelRequest;
(function (DeleteSmsChannelRequest) {
    function isa(o) {
        return __isa(o, "DeleteSmsChannelRequest");
    }
    DeleteSmsChannelRequest.isa = isa;
})(DeleteSmsChannelRequest || (DeleteSmsChannelRequest = {}));
export var DeleteSmsChannelResponse;
(function (DeleteSmsChannelResponse) {
    function isa(o) {
        return __isa(o, "DeleteSmsChannelResponse");
    }
    DeleteSmsChannelResponse.isa = isa;
})(DeleteSmsChannelResponse || (DeleteSmsChannelResponse = {}));
export var DeleteSmsTemplateRequest;
(function (DeleteSmsTemplateRequest) {
    function isa(o) {
        return __isa(o, "DeleteSmsTemplateRequest");
    }
    DeleteSmsTemplateRequest.isa = isa;
})(DeleteSmsTemplateRequest || (DeleteSmsTemplateRequest = {}));
export var DeleteSmsTemplateResponse;
(function (DeleteSmsTemplateResponse) {
    function isa(o) {
        return __isa(o, "DeleteSmsTemplateResponse");
    }
    DeleteSmsTemplateResponse.isa = isa;
})(DeleteSmsTemplateResponse || (DeleteSmsTemplateResponse = {}));
export var DeleteUserEndpointsRequest;
(function (DeleteUserEndpointsRequest) {
    function isa(o) {
        return __isa(o, "DeleteUserEndpointsRequest");
    }
    DeleteUserEndpointsRequest.isa = isa;
})(DeleteUserEndpointsRequest || (DeleteUserEndpointsRequest = {}));
export var DeleteUserEndpointsResponse;
(function (DeleteUserEndpointsResponse) {
    function isa(o) {
        return __isa(o, "DeleteUserEndpointsResponse");
    }
    DeleteUserEndpointsResponse.isa = isa;
})(DeleteUserEndpointsResponse || (DeleteUserEndpointsResponse = {}));
export var DeleteVoiceChannelRequest;
(function (DeleteVoiceChannelRequest) {
    function isa(o) {
        return __isa(o, "DeleteVoiceChannelRequest");
    }
    DeleteVoiceChannelRequest.isa = isa;
})(DeleteVoiceChannelRequest || (DeleteVoiceChannelRequest = {}));
export var DeleteVoiceChannelResponse;
(function (DeleteVoiceChannelResponse) {
    function isa(o) {
        return __isa(o, "DeleteVoiceChannelResponse");
    }
    DeleteVoiceChannelResponse.isa = isa;
})(DeleteVoiceChannelResponse || (DeleteVoiceChannelResponse = {}));
export var DeleteVoiceTemplateRequest;
(function (DeleteVoiceTemplateRequest) {
    function isa(o) {
        return __isa(o, "DeleteVoiceTemplateRequest");
    }
    DeleteVoiceTemplateRequest.isa = isa;
})(DeleteVoiceTemplateRequest || (DeleteVoiceTemplateRequest = {}));
export var DeleteVoiceTemplateResponse;
(function (DeleteVoiceTemplateResponse) {
    function isa(o) {
        return __isa(o, "DeleteVoiceTemplateResponse");
    }
    DeleteVoiceTemplateResponse.isa = isa;
})(DeleteVoiceTemplateResponse || (DeleteVoiceTemplateResponse = {}));
export var DeliveryStatus;
(function (DeliveryStatus) {
    DeliveryStatus["DUPLICATE"] = "DUPLICATE";
    DeliveryStatus["OPT_OUT"] = "OPT_OUT";
    DeliveryStatus["PERMANENT_FAILURE"] = "PERMANENT_FAILURE";
    DeliveryStatus["SUCCESSFUL"] = "SUCCESSFUL";
    DeliveryStatus["TEMPORARY_FAILURE"] = "TEMPORARY_FAILURE";
    DeliveryStatus["THROTTLED"] = "THROTTLED";
    DeliveryStatus["UNKNOWN_FAILURE"] = "UNKNOWN_FAILURE";
})(DeliveryStatus || (DeliveryStatus = {}));
export var DimensionType;
(function (DimensionType) {
    DimensionType["EXCLUSIVE"] = "EXCLUSIVE";
    DimensionType["INCLUSIVE"] = "INCLUSIVE";
})(DimensionType || (DimensionType = {}));
export var DirectMessageConfiguration;
(function (DirectMessageConfiguration) {
    function isa(o) {
        return __isa(o, "DirectMessageConfiguration");
    }
    DirectMessageConfiguration.isa = isa;
})(DirectMessageConfiguration || (DirectMessageConfiguration = {}));
export var Duration;
(function (Duration) {
    Duration["DAY_14"] = "DAY_14";
    Duration["DAY_30"] = "DAY_30";
    Duration["DAY_7"] = "DAY_7";
    Duration["HR_24"] = "HR_24";
})(Duration || (Duration = {}));
export var EmailChannelRequest;
(function (EmailChannelRequest) {
    function isa(o) {
        return __isa(o, "EmailChannelRequest");
    }
    EmailChannelRequest.isa = isa;
})(EmailChannelRequest || (EmailChannelRequest = {}));
export var EmailChannelResponse;
(function (EmailChannelResponse) {
    function isa(o) {
        return __isa(o, "EmailChannelResponse");
    }
    EmailChannelResponse.isa = isa;
})(EmailChannelResponse || (EmailChannelResponse = {}));
export var EmailMessage;
(function (EmailMessage) {
    function isa(o) {
        return __isa(o, "EmailMessage");
    }
    EmailMessage.isa = isa;
})(EmailMessage || (EmailMessage = {}));
export var EmailMessageActivity;
(function (EmailMessageActivity) {
    function isa(o) {
        return __isa(o, "EmailMessageActivity");
    }
    EmailMessageActivity.isa = isa;
})(EmailMessageActivity || (EmailMessageActivity = {}));
export var EmailTemplateRequest;
(function (EmailTemplateRequest) {
    function isa(o) {
        return __isa(o, "EmailTemplateRequest");
    }
    EmailTemplateRequest.isa = isa;
})(EmailTemplateRequest || (EmailTemplateRequest = {}));
export var EmailTemplateResponse;
(function (EmailTemplateResponse) {
    function isa(o) {
        return __isa(o, "EmailTemplateResponse");
    }
    EmailTemplateResponse.isa = isa;
})(EmailTemplateResponse || (EmailTemplateResponse = {}));
export var EndpointBatchItem;
(function (EndpointBatchItem) {
    function isa(o) {
        return __isa(o, "EndpointBatchItem");
    }
    EndpointBatchItem.isa = isa;
})(EndpointBatchItem || (EndpointBatchItem = {}));
export var EndpointBatchRequest;
(function (EndpointBatchRequest) {
    function isa(o) {
        return __isa(o, "EndpointBatchRequest");
    }
    EndpointBatchRequest.isa = isa;
})(EndpointBatchRequest || (EndpointBatchRequest = {}));
export var EndpointDemographic;
(function (EndpointDemographic) {
    function isa(o) {
        return __isa(o, "EndpointDemographic");
    }
    EndpointDemographic.isa = isa;
})(EndpointDemographic || (EndpointDemographic = {}));
export var EndpointItemResponse;
(function (EndpointItemResponse) {
    function isa(o) {
        return __isa(o, "EndpointItemResponse");
    }
    EndpointItemResponse.isa = isa;
})(EndpointItemResponse || (EndpointItemResponse = {}));
export var EndpointLocation;
(function (EndpointLocation) {
    function isa(o) {
        return __isa(o, "EndpointLocation");
    }
    EndpointLocation.isa = isa;
})(EndpointLocation || (EndpointLocation = {}));
export var EndpointMessageResult;
(function (EndpointMessageResult) {
    function isa(o) {
        return __isa(o, "EndpointMessageResult");
    }
    EndpointMessageResult.isa = isa;
})(EndpointMessageResult || (EndpointMessageResult = {}));
export var EndpointRequest;
(function (EndpointRequest) {
    function isa(o) {
        return __isa(o, "EndpointRequest");
    }
    EndpointRequest.isa = isa;
})(EndpointRequest || (EndpointRequest = {}));
export var EndpointResponse;
(function (EndpointResponse) {
    function isa(o) {
        return __isa(o, "EndpointResponse");
    }
    EndpointResponse.isa = isa;
})(EndpointResponse || (EndpointResponse = {}));
export var EndpointSendConfiguration;
(function (EndpointSendConfiguration) {
    function isa(o) {
        return __isa(o, "EndpointSendConfiguration");
    }
    EndpointSendConfiguration.isa = isa;
})(EndpointSendConfiguration || (EndpointSendConfiguration = {}));
export var EndpointUser;
(function (EndpointUser) {
    function isa(o) {
        return __isa(o, "EndpointUser");
    }
    EndpointUser.isa = isa;
})(EndpointUser || (EndpointUser = {}));
export var EndpointsResponse;
(function (EndpointsResponse) {
    function isa(o) {
        return __isa(o, "EndpointsResponse");
    }
    EndpointsResponse.isa = isa;
})(EndpointsResponse || (EndpointsResponse = {}));
export var Event;
(function (Event) {
    function isa(o) {
        return __isa(o, "Event");
    }
    Event.isa = isa;
})(Event || (Event = {}));
export var EventCondition;
(function (EventCondition) {
    function isa(o) {
        return __isa(o, "EventCondition");
    }
    EventCondition.isa = isa;
})(EventCondition || (EventCondition = {}));
export var EventDimensions;
(function (EventDimensions) {
    function isa(o) {
        return __isa(o, "EventDimensions");
    }
    EventDimensions.isa = isa;
})(EventDimensions || (EventDimensions = {}));
export var EventItemResponse;
(function (EventItemResponse) {
    function isa(o) {
        return __isa(o, "EventItemResponse");
    }
    EventItemResponse.isa = isa;
})(EventItemResponse || (EventItemResponse = {}));
export var EventStream;
(function (EventStream) {
    function isa(o) {
        return __isa(o, "EventStream");
    }
    EventStream.isa = isa;
})(EventStream || (EventStream = {}));
export var EventsBatch;
(function (EventsBatch) {
    function isa(o) {
        return __isa(o, "EventsBatch");
    }
    EventsBatch.isa = isa;
})(EventsBatch || (EventsBatch = {}));
export var EventsRequest;
(function (EventsRequest) {
    function isa(o) {
        return __isa(o, "EventsRequest");
    }
    EventsRequest.isa = isa;
})(EventsRequest || (EventsRequest = {}));
export var EventsResponse;
(function (EventsResponse) {
    function isa(o) {
        return __isa(o, "EventsResponse");
    }
    EventsResponse.isa = isa;
})(EventsResponse || (EventsResponse = {}));
export var ExportJobRequest;
(function (ExportJobRequest) {
    function isa(o) {
        return __isa(o, "ExportJobRequest");
    }
    ExportJobRequest.isa = isa;
})(ExportJobRequest || (ExportJobRequest = {}));
export var ExportJobResource;
(function (ExportJobResource) {
    function isa(o) {
        return __isa(o, "ExportJobResource");
    }
    ExportJobResource.isa = isa;
})(ExportJobResource || (ExportJobResource = {}));
export var ExportJobResponse;
(function (ExportJobResponse) {
    function isa(o) {
        return __isa(o, "ExportJobResponse");
    }
    ExportJobResponse.isa = isa;
})(ExportJobResponse || (ExportJobResponse = {}));
export var ExportJobsResponse;
(function (ExportJobsResponse) {
    function isa(o) {
        return __isa(o, "ExportJobsResponse");
    }
    ExportJobsResponse.isa = isa;
})(ExportJobsResponse || (ExportJobsResponse = {}));
export var FilterType;
(function (FilterType) {
    FilterType["ENDPOINT"] = "ENDPOINT";
    FilterType["SYSTEM"] = "SYSTEM";
})(FilterType || (FilterType = {}));
export var ForbiddenException;
(function (ForbiddenException) {
    function isa(o) {
        return __isa(o, "ForbiddenException");
    }
    ForbiddenException.isa = isa;
})(ForbiddenException || (ForbiddenException = {}));
export var Format;
(function (Format) {
    Format["CSV"] = "CSV";
    Format["JSON"] = "JSON";
})(Format || (Format = {}));
export var Frequency;
(function (Frequency) {
    Frequency["DAILY"] = "DAILY";
    Frequency["EVENT"] = "EVENT";
    Frequency["HOURLY"] = "HOURLY";
    Frequency["MONTHLY"] = "MONTHLY";
    Frequency["ONCE"] = "ONCE";
    Frequency["WEEKLY"] = "WEEKLY";
})(Frequency || (Frequency = {}));
export var GCMChannelRequest;
(function (GCMChannelRequest) {
    function isa(o) {
        return __isa(o, "GCMChannelRequest");
    }
    GCMChannelRequest.isa = isa;
})(GCMChannelRequest || (GCMChannelRequest = {}));
export var GCMChannelResponse;
(function (GCMChannelResponse) {
    function isa(o) {
        return __isa(o, "GCMChannelResponse");
    }
    GCMChannelResponse.isa = isa;
})(GCMChannelResponse || (GCMChannelResponse = {}));
export var GCMMessage;
(function (GCMMessage) {
    function isa(o) {
        return __isa(o, "GCMMessage");
    }
    GCMMessage.isa = isa;
})(GCMMessage || (GCMMessage = {}));
export var GPSCoordinates;
(function (GPSCoordinates) {
    function isa(o) {
        return __isa(o, "GPSCoordinates");
    }
    GPSCoordinates.isa = isa;
})(GPSCoordinates || (GPSCoordinates = {}));
export var GPSPointDimension;
(function (GPSPointDimension) {
    function isa(o) {
        return __isa(o, "GPSPointDimension");
    }
    GPSPointDimension.isa = isa;
})(GPSPointDimension || (GPSPointDimension = {}));
export var GetAdmChannelRequest;
(function (GetAdmChannelRequest) {
    function isa(o) {
        return __isa(o, "GetAdmChannelRequest");
    }
    GetAdmChannelRequest.isa = isa;
})(GetAdmChannelRequest || (GetAdmChannelRequest = {}));
export var GetAdmChannelResponse;
(function (GetAdmChannelResponse) {
    function isa(o) {
        return __isa(o, "GetAdmChannelResponse");
    }
    GetAdmChannelResponse.isa = isa;
})(GetAdmChannelResponse || (GetAdmChannelResponse = {}));
export var GetApnsChannelRequest;
(function (GetApnsChannelRequest) {
    function isa(o) {
        return __isa(o, "GetApnsChannelRequest");
    }
    GetApnsChannelRequest.isa = isa;
})(GetApnsChannelRequest || (GetApnsChannelRequest = {}));
export var GetApnsChannelResponse;
(function (GetApnsChannelResponse) {
    function isa(o) {
        return __isa(o, "GetApnsChannelResponse");
    }
    GetApnsChannelResponse.isa = isa;
})(GetApnsChannelResponse || (GetApnsChannelResponse = {}));
export var GetApnsSandboxChannelRequest;
(function (GetApnsSandboxChannelRequest) {
    function isa(o) {
        return __isa(o, "GetApnsSandboxChannelRequest");
    }
    GetApnsSandboxChannelRequest.isa = isa;
})(GetApnsSandboxChannelRequest || (GetApnsSandboxChannelRequest = {}));
export var GetApnsSandboxChannelResponse;
(function (GetApnsSandboxChannelResponse) {
    function isa(o) {
        return __isa(o, "GetApnsSandboxChannelResponse");
    }
    GetApnsSandboxChannelResponse.isa = isa;
})(GetApnsSandboxChannelResponse || (GetApnsSandboxChannelResponse = {}));
export var GetApnsVoipChannelRequest;
(function (GetApnsVoipChannelRequest) {
    function isa(o) {
        return __isa(o, "GetApnsVoipChannelRequest");
    }
    GetApnsVoipChannelRequest.isa = isa;
})(GetApnsVoipChannelRequest || (GetApnsVoipChannelRequest = {}));
export var GetApnsVoipChannelResponse;
(function (GetApnsVoipChannelResponse) {
    function isa(o) {
        return __isa(o, "GetApnsVoipChannelResponse");
    }
    GetApnsVoipChannelResponse.isa = isa;
})(GetApnsVoipChannelResponse || (GetApnsVoipChannelResponse = {}));
export var GetApnsVoipSandboxChannelRequest;
(function (GetApnsVoipSandboxChannelRequest) {
    function isa(o) {
        return __isa(o, "GetApnsVoipSandboxChannelRequest");
    }
    GetApnsVoipSandboxChannelRequest.isa = isa;
})(GetApnsVoipSandboxChannelRequest || (GetApnsVoipSandboxChannelRequest = {}));
export var GetApnsVoipSandboxChannelResponse;
(function (GetApnsVoipSandboxChannelResponse) {
    function isa(o) {
        return __isa(o, "GetApnsVoipSandboxChannelResponse");
    }
    GetApnsVoipSandboxChannelResponse.isa = isa;
})(GetApnsVoipSandboxChannelResponse || (GetApnsVoipSandboxChannelResponse = {}));
export var GetAppRequest;
(function (GetAppRequest) {
    function isa(o) {
        return __isa(o, "GetAppRequest");
    }
    GetAppRequest.isa = isa;
})(GetAppRequest || (GetAppRequest = {}));
export var GetAppResponse;
(function (GetAppResponse) {
    function isa(o) {
        return __isa(o, "GetAppResponse");
    }
    GetAppResponse.isa = isa;
})(GetAppResponse || (GetAppResponse = {}));
export var GetApplicationDateRangeKpiRequest;
(function (GetApplicationDateRangeKpiRequest) {
    function isa(o) {
        return __isa(o, "GetApplicationDateRangeKpiRequest");
    }
    GetApplicationDateRangeKpiRequest.isa = isa;
})(GetApplicationDateRangeKpiRequest || (GetApplicationDateRangeKpiRequest = {}));
export var GetApplicationDateRangeKpiResponse;
(function (GetApplicationDateRangeKpiResponse) {
    function isa(o) {
        return __isa(o, "GetApplicationDateRangeKpiResponse");
    }
    GetApplicationDateRangeKpiResponse.isa = isa;
})(GetApplicationDateRangeKpiResponse || (GetApplicationDateRangeKpiResponse = {}));
export var GetApplicationSettingsRequest;
(function (GetApplicationSettingsRequest) {
    function isa(o) {
        return __isa(o, "GetApplicationSettingsRequest");
    }
    GetApplicationSettingsRequest.isa = isa;
})(GetApplicationSettingsRequest || (GetApplicationSettingsRequest = {}));
export var GetApplicationSettingsResponse;
(function (GetApplicationSettingsResponse) {
    function isa(o) {
        return __isa(o, "GetApplicationSettingsResponse");
    }
    GetApplicationSettingsResponse.isa = isa;
})(GetApplicationSettingsResponse || (GetApplicationSettingsResponse = {}));
export var GetAppsRequest;
(function (GetAppsRequest) {
    function isa(o) {
        return __isa(o, "GetAppsRequest");
    }
    GetAppsRequest.isa = isa;
})(GetAppsRequest || (GetAppsRequest = {}));
export var GetAppsResponse;
(function (GetAppsResponse) {
    function isa(o) {
        return __isa(o, "GetAppsResponse");
    }
    GetAppsResponse.isa = isa;
})(GetAppsResponse || (GetAppsResponse = {}));
export var GetBaiduChannelRequest;
(function (GetBaiduChannelRequest) {
    function isa(o) {
        return __isa(o, "GetBaiduChannelRequest");
    }
    GetBaiduChannelRequest.isa = isa;
})(GetBaiduChannelRequest || (GetBaiduChannelRequest = {}));
export var GetBaiduChannelResponse;
(function (GetBaiduChannelResponse) {
    function isa(o) {
        return __isa(o, "GetBaiduChannelResponse");
    }
    GetBaiduChannelResponse.isa = isa;
})(GetBaiduChannelResponse || (GetBaiduChannelResponse = {}));
export var GetCampaignActivitiesRequest;
(function (GetCampaignActivitiesRequest) {
    function isa(o) {
        return __isa(o, "GetCampaignActivitiesRequest");
    }
    GetCampaignActivitiesRequest.isa = isa;
})(GetCampaignActivitiesRequest || (GetCampaignActivitiesRequest = {}));
export var GetCampaignActivitiesResponse;
(function (GetCampaignActivitiesResponse) {
    function isa(o) {
        return __isa(o, "GetCampaignActivitiesResponse");
    }
    GetCampaignActivitiesResponse.isa = isa;
})(GetCampaignActivitiesResponse || (GetCampaignActivitiesResponse = {}));
export var GetCampaignDateRangeKpiRequest;
(function (GetCampaignDateRangeKpiRequest) {
    function isa(o) {
        return __isa(o, "GetCampaignDateRangeKpiRequest");
    }
    GetCampaignDateRangeKpiRequest.isa = isa;
})(GetCampaignDateRangeKpiRequest || (GetCampaignDateRangeKpiRequest = {}));
export var GetCampaignDateRangeKpiResponse;
(function (GetCampaignDateRangeKpiResponse) {
    function isa(o) {
        return __isa(o, "GetCampaignDateRangeKpiResponse");
    }
    GetCampaignDateRangeKpiResponse.isa = isa;
})(GetCampaignDateRangeKpiResponse || (GetCampaignDateRangeKpiResponse = {}));
export var GetCampaignRequest;
(function (GetCampaignRequest) {
    function isa(o) {
        return __isa(o, "GetCampaignRequest");
    }
    GetCampaignRequest.isa = isa;
})(GetCampaignRequest || (GetCampaignRequest = {}));
export var GetCampaignResponse;
(function (GetCampaignResponse) {
    function isa(o) {
        return __isa(o, "GetCampaignResponse");
    }
    GetCampaignResponse.isa = isa;
})(GetCampaignResponse || (GetCampaignResponse = {}));
export var GetCampaignVersionRequest;
(function (GetCampaignVersionRequest) {
    function isa(o) {
        return __isa(o, "GetCampaignVersionRequest");
    }
    GetCampaignVersionRequest.isa = isa;
})(GetCampaignVersionRequest || (GetCampaignVersionRequest = {}));
export var GetCampaignVersionResponse;
(function (GetCampaignVersionResponse) {
    function isa(o) {
        return __isa(o, "GetCampaignVersionResponse");
    }
    GetCampaignVersionResponse.isa = isa;
})(GetCampaignVersionResponse || (GetCampaignVersionResponse = {}));
export var GetCampaignVersionsRequest;
(function (GetCampaignVersionsRequest) {
    function isa(o) {
        return __isa(o, "GetCampaignVersionsRequest");
    }
    GetCampaignVersionsRequest.isa = isa;
})(GetCampaignVersionsRequest || (GetCampaignVersionsRequest = {}));
export var GetCampaignVersionsResponse;
(function (GetCampaignVersionsResponse) {
    function isa(o) {
        return __isa(o, "GetCampaignVersionsResponse");
    }
    GetCampaignVersionsResponse.isa = isa;
})(GetCampaignVersionsResponse || (GetCampaignVersionsResponse = {}));
export var GetCampaignsRequest;
(function (GetCampaignsRequest) {
    function isa(o) {
        return __isa(o, "GetCampaignsRequest");
    }
    GetCampaignsRequest.isa = isa;
})(GetCampaignsRequest || (GetCampaignsRequest = {}));
export var GetCampaignsResponse;
(function (GetCampaignsResponse) {
    function isa(o) {
        return __isa(o, "GetCampaignsResponse");
    }
    GetCampaignsResponse.isa = isa;
})(GetCampaignsResponse || (GetCampaignsResponse = {}));
export var GetChannelsRequest;
(function (GetChannelsRequest) {
    function isa(o) {
        return __isa(o, "GetChannelsRequest");
    }
    GetChannelsRequest.isa = isa;
})(GetChannelsRequest || (GetChannelsRequest = {}));
export var GetChannelsResponse;
(function (GetChannelsResponse) {
    function isa(o) {
        return __isa(o, "GetChannelsResponse");
    }
    GetChannelsResponse.isa = isa;
})(GetChannelsResponse || (GetChannelsResponse = {}));
export var GetEmailChannelRequest;
(function (GetEmailChannelRequest) {
    function isa(o) {
        return __isa(o, "GetEmailChannelRequest");
    }
    GetEmailChannelRequest.isa = isa;
})(GetEmailChannelRequest || (GetEmailChannelRequest = {}));
export var GetEmailChannelResponse;
(function (GetEmailChannelResponse) {
    function isa(o) {
        return __isa(o, "GetEmailChannelResponse");
    }
    GetEmailChannelResponse.isa = isa;
})(GetEmailChannelResponse || (GetEmailChannelResponse = {}));
export var GetEmailTemplateRequest;
(function (GetEmailTemplateRequest) {
    function isa(o) {
        return __isa(o, "GetEmailTemplateRequest");
    }
    GetEmailTemplateRequest.isa = isa;
})(GetEmailTemplateRequest || (GetEmailTemplateRequest = {}));
export var GetEmailTemplateResponse;
(function (GetEmailTemplateResponse) {
    function isa(o) {
        return __isa(o, "GetEmailTemplateResponse");
    }
    GetEmailTemplateResponse.isa = isa;
})(GetEmailTemplateResponse || (GetEmailTemplateResponse = {}));
export var GetEndpointRequest;
(function (GetEndpointRequest) {
    function isa(o) {
        return __isa(o, "GetEndpointRequest");
    }
    GetEndpointRequest.isa = isa;
})(GetEndpointRequest || (GetEndpointRequest = {}));
export var GetEndpointResponse;
(function (GetEndpointResponse) {
    function isa(o) {
        return __isa(o, "GetEndpointResponse");
    }
    GetEndpointResponse.isa = isa;
})(GetEndpointResponse || (GetEndpointResponse = {}));
export var GetEventStreamRequest;
(function (GetEventStreamRequest) {
    function isa(o) {
        return __isa(o, "GetEventStreamRequest");
    }
    GetEventStreamRequest.isa = isa;
})(GetEventStreamRequest || (GetEventStreamRequest = {}));
export var GetEventStreamResponse;
(function (GetEventStreamResponse) {
    function isa(o) {
        return __isa(o, "GetEventStreamResponse");
    }
    GetEventStreamResponse.isa = isa;
})(GetEventStreamResponse || (GetEventStreamResponse = {}));
export var GetExportJobRequest;
(function (GetExportJobRequest) {
    function isa(o) {
        return __isa(o, "GetExportJobRequest");
    }
    GetExportJobRequest.isa = isa;
})(GetExportJobRequest || (GetExportJobRequest = {}));
export var GetExportJobResponse;
(function (GetExportJobResponse) {
    function isa(o) {
        return __isa(o, "GetExportJobResponse");
    }
    GetExportJobResponse.isa = isa;
})(GetExportJobResponse || (GetExportJobResponse = {}));
export var GetExportJobsRequest;
(function (GetExportJobsRequest) {
    function isa(o) {
        return __isa(o, "GetExportJobsRequest");
    }
    GetExportJobsRequest.isa = isa;
})(GetExportJobsRequest || (GetExportJobsRequest = {}));
export var GetExportJobsResponse;
(function (GetExportJobsResponse) {
    function isa(o) {
        return __isa(o, "GetExportJobsResponse");
    }
    GetExportJobsResponse.isa = isa;
})(GetExportJobsResponse || (GetExportJobsResponse = {}));
export var GetGcmChannelRequest;
(function (GetGcmChannelRequest) {
    function isa(o) {
        return __isa(o, "GetGcmChannelRequest");
    }
    GetGcmChannelRequest.isa = isa;
})(GetGcmChannelRequest || (GetGcmChannelRequest = {}));
export var GetGcmChannelResponse;
(function (GetGcmChannelResponse) {
    function isa(o) {
        return __isa(o, "GetGcmChannelResponse");
    }
    GetGcmChannelResponse.isa = isa;
})(GetGcmChannelResponse || (GetGcmChannelResponse = {}));
export var GetImportJobRequest;
(function (GetImportJobRequest) {
    function isa(o) {
        return __isa(o, "GetImportJobRequest");
    }
    GetImportJobRequest.isa = isa;
})(GetImportJobRequest || (GetImportJobRequest = {}));
export var GetImportJobResponse;
(function (GetImportJobResponse) {
    function isa(o) {
        return __isa(o, "GetImportJobResponse");
    }
    GetImportJobResponse.isa = isa;
})(GetImportJobResponse || (GetImportJobResponse = {}));
export var GetImportJobsRequest;
(function (GetImportJobsRequest) {
    function isa(o) {
        return __isa(o, "GetImportJobsRequest");
    }
    GetImportJobsRequest.isa = isa;
})(GetImportJobsRequest || (GetImportJobsRequest = {}));
export var GetImportJobsResponse;
(function (GetImportJobsResponse) {
    function isa(o) {
        return __isa(o, "GetImportJobsResponse");
    }
    GetImportJobsResponse.isa = isa;
})(GetImportJobsResponse || (GetImportJobsResponse = {}));
export var GetJourneyDateRangeKpiRequest;
(function (GetJourneyDateRangeKpiRequest) {
    function isa(o) {
        return __isa(o, "GetJourneyDateRangeKpiRequest");
    }
    GetJourneyDateRangeKpiRequest.isa = isa;
})(GetJourneyDateRangeKpiRequest || (GetJourneyDateRangeKpiRequest = {}));
export var GetJourneyDateRangeKpiResponse;
(function (GetJourneyDateRangeKpiResponse) {
    function isa(o) {
        return __isa(o, "GetJourneyDateRangeKpiResponse");
    }
    GetJourneyDateRangeKpiResponse.isa = isa;
})(GetJourneyDateRangeKpiResponse || (GetJourneyDateRangeKpiResponse = {}));
export var GetJourneyExecutionActivityMetricsRequest;
(function (GetJourneyExecutionActivityMetricsRequest) {
    function isa(o) {
        return __isa(o, "GetJourneyExecutionActivityMetricsRequest");
    }
    GetJourneyExecutionActivityMetricsRequest.isa = isa;
})(GetJourneyExecutionActivityMetricsRequest || (GetJourneyExecutionActivityMetricsRequest = {}));
export var GetJourneyExecutionActivityMetricsResponse;
(function (GetJourneyExecutionActivityMetricsResponse) {
    function isa(o) {
        return __isa(o, "GetJourneyExecutionActivityMetricsResponse");
    }
    GetJourneyExecutionActivityMetricsResponse.isa = isa;
})(GetJourneyExecutionActivityMetricsResponse || (GetJourneyExecutionActivityMetricsResponse = {}));
export var GetJourneyExecutionMetricsRequest;
(function (GetJourneyExecutionMetricsRequest) {
    function isa(o) {
        return __isa(o, "GetJourneyExecutionMetricsRequest");
    }
    GetJourneyExecutionMetricsRequest.isa = isa;
})(GetJourneyExecutionMetricsRequest || (GetJourneyExecutionMetricsRequest = {}));
export var GetJourneyExecutionMetricsResponse;
(function (GetJourneyExecutionMetricsResponse) {
    function isa(o) {
        return __isa(o, "GetJourneyExecutionMetricsResponse");
    }
    GetJourneyExecutionMetricsResponse.isa = isa;
})(GetJourneyExecutionMetricsResponse || (GetJourneyExecutionMetricsResponse = {}));
export var GetJourneyRequest;
(function (GetJourneyRequest) {
    function isa(o) {
        return __isa(o, "GetJourneyRequest");
    }
    GetJourneyRequest.isa = isa;
})(GetJourneyRequest || (GetJourneyRequest = {}));
export var GetJourneyResponse;
(function (GetJourneyResponse) {
    function isa(o) {
        return __isa(o, "GetJourneyResponse");
    }
    GetJourneyResponse.isa = isa;
})(GetJourneyResponse || (GetJourneyResponse = {}));
export var GetPushTemplateRequest;
(function (GetPushTemplateRequest) {
    function isa(o) {
        return __isa(o, "GetPushTemplateRequest");
    }
    GetPushTemplateRequest.isa = isa;
})(GetPushTemplateRequest || (GetPushTemplateRequest = {}));
export var GetPushTemplateResponse;
(function (GetPushTemplateResponse) {
    function isa(o) {
        return __isa(o, "GetPushTemplateResponse");
    }
    GetPushTemplateResponse.isa = isa;
})(GetPushTemplateResponse || (GetPushTemplateResponse = {}));
export var GetSegmentExportJobsRequest;
(function (GetSegmentExportJobsRequest) {
    function isa(o) {
        return __isa(o, "GetSegmentExportJobsRequest");
    }
    GetSegmentExportJobsRequest.isa = isa;
})(GetSegmentExportJobsRequest || (GetSegmentExportJobsRequest = {}));
export var GetSegmentExportJobsResponse;
(function (GetSegmentExportJobsResponse) {
    function isa(o) {
        return __isa(o, "GetSegmentExportJobsResponse");
    }
    GetSegmentExportJobsResponse.isa = isa;
})(GetSegmentExportJobsResponse || (GetSegmentExportJobsResponse = {}));
export var GetSegmentImportJobsRequest;
(function (GetSegmentImportJobsRequest) {
    function isa(o) {
        return __isa(o, "GetSegmentImportJobsRequest");
    }
    GetSegmentImportJobsRequest.isa = isa;
})(GetSegmentImportJobsRequest || (GetSegmentImportJobsRequest = {}));
export var GetSegmentImportJobsResponse;
(function (GetSegmentImportJobsResponse) {
    function isa(o) {
        return __isa(o, "GetSegmentImportJobsResponse");
    }
    GetSegmentImportJobsResponse.isa = isa;
})(GetSegmentImportJobsResponse || (GetSegmentImportJobsResponse = {}));
export var GetSegmentRequest;
(function (GetSegmentRequest) {
    function isa(o) {
        return __isa(o, "GetSegmentRequest");
    }
    GetSegmentRequest.isa = isa;
})(GetSegmentRequest || (GetSegmentRequest = {}));
export var GetSegmentResponse;
(function (GetSegmentResponse) {
    function isa(o) {
        return __isa(o, "GetSegmentResponse");
    }
    GetSegmentResponse.isa = isa;
})(GetSegmentResponse || (GetSegmentResponse = {}));
export var GetSegmentVersionRequest;
(function (GetSegmentVersionRequest) {
    function isa(o) {
        return __isa(o, "GetSegmentVersionRequest");
    }
    GetSegmentVersionRequest.isa = isa;
})(GetSegmentVersionRequest || (GetSegmentVersionRequest = {}));
export var GetSegmentVersionResponse;
(function (GetSegmentVersionResponse) {
    function isa(o) {
        return __isa(o, "GetSegmentVersionResponse");
    }
    GetSegmentVersionResponse.isa = isa;
})(GetSegmentVersionResponse || (GetSegmentVersionResponse = {}));
export var GetSegmentVersionsRequest;
(function (GetSegmentVersionsRequest) {
    function isa(o) {
        return __isa(o, "GetSegmentVersionsRequest");
    }
    GetSegmentVersionsRequest.isa = isa;
})(GetSegmentVersionsRequest || (GetSegmentVersionsRequest = {}));
export var GetSegmentVersionsResponse;
(function (GetSegmentVersionsResponse) {
    function isa(o) {
        return __isa(o, "GetSegmentVersionsResponse");
    }
    GetSegmentVersionsResponse.isa = isa;
})(GetSegmentVersionsResponse || (GetSegmentVersionsResponse = {}));
export var GetSegmentsRequest;
(function (GetSegmentsRequest) {
    function isa(o) {
        return __isa(o, "GetSegmentsRequest");
    }
    GetSegmentsRequest.isa = isa;
})(GetSegmentsRequest || (GetSegmentsRequest = {}));
export var GetSegmentsResponse;
(function (GetSegmentsResponse) {
    function isa(o) {
        return __isa(o, "GetSegmentsResponse");
    }
    GetSegmentsResponse.isa = isa;
})(GetSegmentsResponse || (GetSegmentsResponse = {}));
export var GetSmsChannelRequest;
(function (GetSmsChannelRequest) {
    function isa(o) {
        return __isa(o, "GetSmsChannelRequest");
    }
    GetSmsChannelRequest.isa = isa;
})(GetSmsChannelRequest || (GetSmsChannelRequest = {}));
export var GetSmsChannelResponse;
(function (GetSmsChannelResponse) {
    function isa(o) {
        return __isa(o, "GetSmsChannelResponse");
    }
    GetSmsChannelResponse.isa = isa;
})(GetSmsChannelResponse || (GetSmsChannelResponse = {}));
export var GetSmsTemplateRequest;
(function (GetSmsTemplateRequest) {
    function isa(o) {
        return __isa(o, "GetSmsTemplateRequest");
    }
    GetSmsTemplateRequest.isa = isa;
})(GetSmsTemplateRequest || (GetSmsTemplateRequest = {}));
export var GetSmsTemplateResponse;
(function (GetSmsTemplateResponse) {
    function isa(o) {
        return __isa(o, "GetSmsTemplateResponse");
    }
    GetSmsTemplateResponse.isa = isa;
})(GetSmsTemplateResponse || (GetSmsTemplateResponse = {}));
export var GetUserEndpointsRequest;
(function (GetUserEndpointsRequest) {
    function isa(o) {
        return __isa(o, "GetUserEndpointsRequest");
    }
    GetUserEndpointsRequest.isa = isa;
})(GetUserEndpointsRequest || (GetUserEndpointsRequest = {}));
export var GetUserEndpointsResponse;
(function (GetUserEndpointsResponse) {
    function isa(o) {
        return __isa(o, "GetUserEndpointsResponse");
    }
    GetUserEndpointsResponse.isa = isa;
})(GetUserEndpointsResponse || (GetUserEndpointsResponse = {}));
export var GetVoiceChannelRequest;
(function (GetVoiceChannelRequest) {
    function isa(o) {
        return __isa(o, "GetVoiceChannelRequest");
    }
    GetVoiceChannelRequest.isa = isa;
})(GetVoiceChannelRequest || (GetVoiceChannelRequest = {}));
export var GetVoiceChannelResponse;
(function (GetVoiceChannelResponse) {
    function isa(o) {
        return __isa(o, "GetVoiceChannelResponse");
    }
    GetVoiceChannelResponse.isa = isa;
})(GetVoiceChannelResponse || (GetVoiceChannelResponse = {}));
export var GetVoiceTemplateRequest;
(function (GetVoiceTemplateRequest) {
    function isa(o) {
        return __isa(o, "GetVoiceTemplateRequest");
    }
    GetVoiceTemplateRequest.isa = isa;
})(GetVoiceTemplateRequest || (GetVoiceTemplateRequest = {}));
export var GetVoiceTemplateResponse;
(function (GetVoiceTemplateResponse) {
    function isa(o) {
        return __isa(o, "GetVoiceTemplateResponse");
    }
    GetVoiceTemplateResponse.isa = isa;
})(GetVoiceTemplateResponse || (GetVoiceTemplateResponse = {}));
export var HoldoutActivity;
(function (HoldoutActivity) {
    function isa(o) {
        return __isa(o, "HoldoutActivity");
    }
    HoldoutActivity.isa = isa;
})(HoldoutActivity || (HoldoutActivity = {}));
export var ImportJobRequest;
(function (ImportJobRequest) {
    function isa(o) {
        return __isa(o, "ImportJobRequest");
    }
    ImportJobRequest.isa = isa;
})(ImportJobRequest || (ImportJobRequest = {}));
export var ImportJobResource;
(function (ImportJobResource) {
    function isa(o) {
        return __isa(o, "ImportJobResource");
    }
    ImportJobResource.isa = isa;
})(ImportJobResource || (ImportJobResource = {}));
export var ImportJobResponse;
(function (ImportJobResponse) {
    function isa(o) {
        return __isa(o, "ImportJobResponse");
    }
    ImportJobResponse.isa = isa;
})(ImportJobResponse || (ImportJobResponse = {}));
export var ImportJobsResponse;
(function (ImportJobsResponse) {
    function isa(o) {
        return __isa(o, "ImportJobsResponse");
    }
    ImportJobsResponse.isa = isa;
})(ImportJobsResponse || (ImportJobsResponse = {}));
export var Include;
(function (Include) {
    Include["ALL"] = "ALL";
    Include["ANY"] = "ANY";
    Include["NONE"] = "NONE";
})(Include || (Include = {}));
export var InternalServerErrorException;
(function (InternalServerErrorException) {
    function isa(o) {
        return __isa(o, "InternalServerErrorException");
    }
    InternalServerErrorException.isa = isa;
})(InternalServerErrorException || (InternalServerErrorException = {}));
export var ItemResponse;
(function (ItemResponse) {
    function isa(o) {
        return __isa(o, "ItemResponse");
    }
    ItemResponse.isa = isa;
})(ItemResponse || (ItemResponse = {}));
export var JobStatus;
(function (JobStatus) {
    JobStatus["COMPLETED"] = "COMPLETED";
    JobStatus["COMPLETING"] = "COMPLETING";
    JobStatus["CREATED"] = "CREATED";
    JobStatus["FAILED"] = "FAILED";
    JobStatus["FAILING"] = "FAILING";
    JobStatus["INITIALIZING"] = "INITIALIZING";
    JobStatus["PENDING_JOB"] = "PENDING_JOB";
    JobStatus["PREPARING_FOR_INITIALIZATION"] = "PREPARING_FOR_INITIALIZATION";
    JobStatus["PROCESSING"] = "PROCESSING";
})(JobStatus || (JobStatus = {}));
export var JourneyDateRangeKpiResponse;
(function (JourneyDateRangeKpiResponse) {
    function isa(o) {
        return __isa(o, "JourneyDateRangeKpiResponse");
    }
    JourneyDateRangeKpiResponse.isa = isa;
})(JourneyDateRangeKpiResponse || (JourneyDateRangeKpiResponse = {}));
export var JourneyEmailMessage;
(function (JourneyEmailMessage) {
    function isa(o) {
        return __isa(o, "JourneyEmailMessage");
    }
    JourneyEmailMessage.isa = isa;
})(JourneyEmailMessage || (JourneyEmailMessage = {}));
export var JourneyExecutionActivityMetricsResponse;
(function (JourneyExecutionActivityMetricsResponse) {
    function isa(o) {
        return __isa(o, "JourneyExecutionActivityMetricsResponse");
    }
    JourneyExecutionActivityMetricsResponse.isa = isa;
})(JourneyExecutionActivityMetricsResponse || (JourneyExecutionActivityMetricsResponse = {}));
export var JourneyExecutionMetricsResponse;
(function (JourneyExecutionMetricsResponse) {
    function isa(o) {
        return __isa(o, "JourneyExecutionMetricsResponse");
    }
    JourneyExecutionMetricsResponse.isa = isa;
})(JourneyExecutionMetricsResponse || (JourneyExecutionMetricsResponse = {}));
export var JourneyLimits;
(function (JourneyLimits) {
    function isa(o) {
        return __isa(o, "JourneyLimits");
    }
    JourneyLimits.isa = isa;
})(JourneyLimits || (JourneyLimits = {}));
export var JourneyResponse;
(function (JourneyResponse) {
    function isa(o) {
        return __isa(o, "JourneyResponse");
    }
    JourneyResponse.isa = isa;
})(JourneyResponse || (JourneyResponse = {}));
export var JourneySchedule;
(function (JourneySchedule) {
    function isa(o) {
        return __isa(o, "JourneySchedule");
    }
    JourneySchedule.isa = isa;
})(JourneySchedule || (JourneySchedule = {}));
export var JourneyStateRequest;
(function (JourneyStateRequest) {
    function isa(o) {
        return __isa(o, "JourneyStateRequest");
    }
    JourneyStateRequest.isa = isa;
})(JourneyStateRequest || (JourneyStateRequest = {}));
export var JourneysResponse;
(function (JourneysResponse) {
    function isa(o) {
        return __isa(o, "JourneysResponse");
    }
    JourneysResponse.isa = isa;
})(JourneysResponse || (JourneysResponse = {}));
export var ListJourneysRequest;
(function (ListJourneysRequest) {
    function isa(o) {
        return __isa(o, "ListJourneysRequest");
    }
    ListJourneysRequest.isa = isa;
})(ListJourneysRequest || (ListJourneysRequest = {}));
export var ListJourneysResponse;
(function (ListJourneysResponse) {
    function isa(o) {
        return __isa(o, "ListJourneysResponse");
    }
    ListJourneysResponse.isa = isa;
})(ListJourneysResponse || (ListJourneysResponse = {}));
export var ListTagsForResourceRequest;
(function (ListTagsForResourceRequest) {
    function isa(o) {
        return __isa(o, "ListTagsForResourceRequest");
    }
    ListTagsForResourceRequest.isa = isa;
})(ListTagsForResourceRequest || (ListTagsForResourceRequest = {}));
export var ListTagsForResourceResponse;
(function (ListTagsForResourceResponse) {
    function isa(o) {
        return __isa(o, "ListTagsForResourceResponse");
    }
    ListTagsForResourceResponse.isa = isa;
})(ListTagsForResourceResponse || (ListTagsForResourceResponse = {}));
export var ListTemplateVersionsRequest;
(function (ListTemplateVersionsRequest) {
    function isa(o) {
        return __isa(o, "ListTemplateVersionsRequest");
    }
    ListTemplateVersionsRequest.isa = isa;
})(ListTemplateVersionsRequest || (ListTemplateVersionsRequest = {}));
export var ListTemplateVersionsResponse;
(function (ListTemplateVersionsResponse) {
    function isa(o) {
        return __isa(o, "ListTemplateVersionsResponse");
    }
    ListTemplateVersionsResponse.isa = isa;
})(ListTemplateVersionsResponse || (ListTemplateVersionsResponse = {}));
export var ListTemplatesRequest;
(function (ListTemplatesRequest) {
    function isa(o) {
        return __isa(o, "ListTemplatesRequest");
    }
    ListTemplatesRequest.isa = isa;
})(ListTemplatesRequest || (ListTemplatesRequest = {}));
export var ListTemplatesResponse;
(function (ListTemplatesResponse) {
    function isa(o) {
        return __isa(o, "ListTemplatesResponse");
    }
    ListTemplatesResponse.isa = isa;
})(ListTemplatesResponse || (ListTemplatesResponse = {}));
export var Message;
(function (Message) {
    function isa(o) {
        return __isa(o, "Message");
    }
    Message.isa = isa;
})(Message || (Message = {}));
export var MessageBody;
(function (MessageBody) {
    function isa(o) {
        return __isa(o, "MessageBody");
    }
    MessageBody.isa = isa;
})(MessageBody || (MessageBody = {}));
export var MessageConfiguration;
(function (MessageConfiguration) {
    function isa(o) {
        return __isa(o, "MessageConfiguration");
    }
    MessageConfiguration.isa = isa;
})(MessageConfiguration || (MessageConfiguration = {}));
export var MessageRequest;
(function (MessageRequest) {
    function isa(o) {
        return __isa(o, "MessageRequest");
    }
    MessageRequest.isa = isa;
})(MessageRequest || (MessageRequest = {}));
export var MessageResponse;
(function (MessageResponse) {
    function isa(o) {
        return __isa(o, "MessageResponse");
    }
    MessageResponse.isa = isa;
})(MessageResponse || (MessageResponse = {}));
export var MessageResult;
(function (MessageResult) {
    function isa(o) {
        return __isa(o, "MessageResult");
    }
    MessageResult.isa = isa;
})(MessageResult || (MessageResult = {}));
export var MessageType;
(function (MessageType) {
    MessageType["PROMOTIONAL"] = "PROMOTIONAL";
    MessageType["TRANSACTIONAL"] = "TRANSACTIONAL";
})(MessageType || (MessageType = {}));
export var MethodNotAllowedException;
(function (MethodNotAllowedException) {
    function isa(o) {
        return __isa(o, "MethodNotAllowedException");
    }
    MethodNotAllowedException.isa = isa;
})(MethodNotAllowedException || (MethodNotAllowedException = {}));
export var MetricDimension;
(function (MetricDimension) {
    function isa(o) {
        return __isa(o, "MetricDimension");
    }
    MetricDimension.isa = isa;
})(MetricDimension || (MetricDimension = {}));
export var Mode;
(function (Mode) {
    Mode["DELIVERY"] = "DELIVERY";
    Mode["FILTER"] = "FILTER";
})(Mode || (Mode = {}));
export var MultiConditionalBranch;
(function (MultiConditionalBranch) {
    function isa(o) {
        return __isa(o, "MultiConditionalBranch");
    }
    MultiConditionalBranch.isa = isa;
})(MultiConditionalBranch || (MultiConditionalBranch = {}));
export var MultiConditionalSplitActivity;
(function (MultiConditionalSplitActivity) {
    function isa(o) {
        return __isa(o, "MultiConditionalSplitActivity");
    }
    MultiConditionalSplitActivity.isa = isa;
})(MultiConditionalSplitActivity || (MultiConditionalSplitActivity = {}));
export var NotFoundException;
(function (NotFoundException) {
    function isa(o) {
        return __isa(o, "NotFoundException");
    }
    NotFoundException.isa = isa;
})(NotFoundException || (NotFoundException = {}));
export var NumberValidateRequest;
(function (NumberValidateRequest) {
    function isa(o) {
        return __isa(o, "NumberValidateRequest");
    }
    NumberValidateRequest.isa = isa;
})(NumberValidateRequest || (NumberValidateRequest = {}));
export var NumberValidateResponse;
(function (NumberValidateResponse) {
    function isa(o) {
        return __isa(o, "NumberValidateResponse");
    }
    NumberValidateResponse.isa = isa;
})(NumberValidateResponse || (NumberValidateResponse = {}));
export var Operator;
(function (Operator) {
    Operator["ALL"] = "ALL";
    Operator["ANY"] = "ANY";
})(Operator || (Operator = {}));
export var PhoneNumberValidateRequest;
(function (PhoneNumberValidateRequest) {
    function isa(o) {
        return __isa(o, "PhoneNumberValidateRequest");
    }
    PhoneNumberValidateRequest.isa = isa;
})(PhoneNumberValidateRequest || (PhoneNumberValidateRequest = {}));
export var PhoneNumberValidateResponse;
(function (PhoneNumberValidateResponse) {
    function isa(o) {
        return __isa(o, "PhoneNumberValidateResponse");
    }
    PhoneNumberValidateResponse.isa = isa;
})(PhoneNumberValidateResponse || (PhoneNumberValidateResponse = {}));
export var PublicEndpoint;
(function (PublicEndpoint) {
    function isa(o) {
        return __isa(o, "PublicEndpoint");
    }
    PublicEndpoint.isa = isa;
})(PublicEndpoint || (PublicEndpoint = {}));
export var PushNotificationTemplateRequest;
(function (PushNotificationTemplateRequest) {
    function isa(o) {
        return __isa(o, "PushNotificationTemplateRequest");
    }
    PushNotificationTemplateRequest.isa = isa;
})(PushNotificationTemplateRequest || (PushNotificationTemplateRequest = {}));
export var PushNotificationTemplateResponse;
(function (PushNotificationTemplateResponse) {
    function isa(o) {
        return __isa(o, "PushNotificationTemplateResponse");
    }
    PushNotificationTemplateResponse.isa = isa;
})(PushNotificationTemplateResponse || (PushNotificationTemplateResponse = {}));
export var PutEventStreamRequest;
(function (PutEventStreamRequest) {
    function isa(o) {
        return __isa(o, "PutEventStreamRequest");
    }
    PutEventStreamRequest.isa = isa;
})(PutEventStreamRequest || (PutEventStreamRequest = {}));
export var PutEventStreamResponse;
(function (PutEventStreamResponse) {
    function isa(o) {
        return __isa(o, "PutEventStreamResponse");
    }
    PutEventStreamResponse.isa = isa;
})(PutEventStreamResponse || (PutEventStreamResponse = {}));
export var PutEventsRequest;
(function (PutEventsRequest) {
    function isa(o) {
        return __isa(o, "PutEventsRequest");
    }
    PutEventsRequest.isa = isa;
})(PutEventsRequest || (PutEventsRequest = {}));
export var PutEventsResponse;
(function (PutEventsResponse) {
    function isa(o) {
        return __isa(o, "PutEventsResponse");
    }
    PutEventsResponse.isa = isa;
})(PutEventsResponse || (PutEventsResponse = {}));
export var QuietTime;
(function (QuietTime) {
    function isa(o) {
        return __isa(o, "QuietTime");
    }
    QuietTime.isa = isa;
})(QuietTime || (QuietTime = {}));
export var RandomSplitActivity;
(function (RandomSplitActivity) {
    function isa(o) {
        return __isa(o, "RandomSplitActivity");
    }
    RandomSplitActivity.isa = isa;
})(RandomSplitActivity || (RandomSplitActivity = {}));
export var RandomSplitEntry;
(function (RandomSplitEntry) {
    function isa(o) {
        return __isa(o, "RandomSplitEntry");
    }
    RandomSplitEntry.isa = isa;
})(RandomSplitEntry || (RandomSplitEntry = {}));
export var RawEmail;
(function (RawEmail) {
    function isa(o) {
        return __isa(o, "RawEmail");
    }
    RawEmail.isa = isa;
})(RawEmail || (RawEmail = {}));
export var RecencyDimension;
(function (RecencyDimension) {
    function isa(o) {
        return __isa(o, "RecencyDimension");
    }
    RecencyDimension.isa = isa;
})(RecencyDimension || (RecencyDimension = {}));
export var RecencyType;
(function (RecencyType) {
    RecencyType["ACTIVE"] = "ACTIVE";
    RecencyType["INACTIVE"] = "INACTIVE";
})(RecencyType || (RecencyType = {}));
export var RemoveAttributesRequest;
(function (RemoveAttributesRequest) {
    function isa(o) {
        return __isa(o, "RemoveAttributesRequest");
    }
    RemoveAttributesRequest.isa = isa;
})(RemoveAttributesRequest || (RemoveAttributesRequest = {}));
export var RemoveAttributesResponse;
(function (RemoveAttributesResponse) {
    function isa(o) {
        return __isa(o, "RemoveAttributesResponse");
    }
    RemoveAttributesResponse.isa = isa;
})(RemoveAttributesResponse || (RemoveAttributesResponse = {}));
export var ResultRow;
(function (ResultRow) {
    function isa(o) {
        return __isa(o, "ResultRow");
    }
    ResultRow.isa = isa;
})(ResultRow || (ResultRow = {}));
export var ResultRowValue;
(function (ResultRowValue) {
    function isa(o) {
        return __isa(o, "ResultRowValue");
    }
    ResultRowValue.isa = isa;
})(ResultRowValue || (ResultRowValue = {}));
export var SMSChannelRequest;
(function (SMSChannelRequest) {
    function isa(o) {
        return __isa(o, "SMSChannelRequest");
    }
    SMSChannelRequest.isa = isa;
})(SMSChannelRequest || (SMSChannelRequest = {}));
export var SMSChannelResponse;
(function (SMSChannelResponse) {
    function isa(o) {
        return __isa(o, "SMSChannelResponse");
    }
    SMSChannelResponse.isa = isa;
})(SMSChannelResponse || (SMSChannelResponse = {}));
export var SMSMessage;
(function (SMSMessage) {
    function isa(o) {
        return __isa(o, "SMSMessage");
    }
    SMSMessage.isa = isa;
})(SMSMessage || (SMSMessage = {}));
export var SMSTemplateRequest;
(function (SMSTemplateRequest) {
    function isa(o) {
        return __isa(o, "SMSTemplateRequest");
    }
    SMSTemplateRequest.isa = isa;
})(SMSTemplateRequest || (SMSTemplateRequest = {}));
export var SMSTemplateResponse;
(function (SMSTemplateResponse) {
    function isa(o) {
        return __isa(o, "SMSTemplateResponse");
    }
    SMSTemplateResponse.isa = isa;
})(SMSTemplateResponse || (SMSTemplateResponse = {}));
export var Schedule;
(function (Schedule) {
    function isa(o) {
        return __isa(o, "Schedule");
    }
    Schedule.isa = isa;
})(Schedule || (Schedule = {}));
export var SegmentBehaviors;
(function (SegmentBehaviors) {
    function isa(o) {
        return __isa(o, "SegmentBehaviors");
    }
    SegmentBehaviors.isa = isa;
})(SegmentBehaviors || (SegmentBehaviors = {}));
export var SegmentCondition;
(function (SegmentCondition) {
    function isa(o) {
        return __isa(o, "SegmentCondition");
    }
    SegmentCondition.isa = isa;
})(SegmentCondition || (SegmentCondition = {}));
export var SegmentDemographics;
(function (SegmentDemographics) {
    function isa(o) {
        return __isa(o, "SegmentDemographics");
    }
    SegmentDemographics.isa = isa;
})(SegmentDemographics || (SegmentDemographics = {}));
export var SegmentDimensions;
(function (SegmentDimensions) {
    function isa(o) {
        return __isa(o, "SegmentDimensions");
    }
    SegmentDimensions.isa = isa;
})(SegmentDimensions || (SegmentDimensions = {}));
export var SegmentGroup;
(function (SegmentGroup) {
    function isa(o) {
        return __isa(o, "SegmentGroup");
    }
    SegmentGroup.isa = isa;
})(SegmentGroup || (SegmentGroup = {}));
export var SegmentGroupList;
(function (SegmentGroupList) {
    function isa(o) {
        return __isa(o, "SegmentGroupList");
    }
    SegmentGroupList.isa = isa;
})(SegmentGroupList || (SegmentGroupList = {}));
export var SegmentImportResource;
(function (SegmentImportResource) {
    function isa(o) {
        return __isa(o, "SegmentImportResource");
    }
    SegmentImportResource.isa = isa;
})(SegmentImportResource || (SegmentImportResource = {}));
export var SegmentLocation;
(function (SegmentLocation) {
    function isa(o) {
        return __isa(o, "SegmentLocation");
    }
    SegmentLocation.isa = isa;
})(SegmentLocation || (SegmentLocation = {}));
export var SegmentReference;
(function (SegmentReference) {
    function isa(o) {
        return __isa(o, "SegmentReference");
    }
    SegmentReference.isa = isa;
})(SegmentReference || (SegmentReference = {}));
export var SegmentResponse;
(function (SegmentResponse) {
    function isa(o) {
        return __isa(o, "SegmentResponse");
    }
    SegmentResponse.isa = isa;
})(SegmentResponse || (SegmentResponse = {}));
export var SegmentType;
(function (SegmentType) {
    SegmentType["DIMENSIONAL"] = "DIMENSIONAL";
    SegmentType["IMPORT"] = "IMPORT";
})(SegmentType || (SegmentType = {}));
export var SegmentsResponse;
(function (SegmentsResponse) {
    function isa(o) {
        return __isa(o, "SegmentsResponse");
    }
    SegmentsResponse.isa = isa;
})(SegmentsResponse || (SegmentsResponse = {}));
export var SendMessagesRequest;
(function (SendMessagesRequest) {
    function isa(o) {
        return __isa(o, "SendMessagesRequest");
    }
    SendMessagesRequest.isa = isa;
})(SendMessagesRequest || (SendMessagesRequest = {}));
export var SendMessagesResponse;
(function (SendMessagesResponse) {
    function isa(o) {
        return __isa(o, "SendMessagesResponse");
    }
    SendMessagesResponse.isa = isa;
})(SendMessagesResponse || (SendMessagesResponse = {}));
export var SendUsersMessageRequest;
(function (SendUsersMessageRequest) {
    function isa(o) {
        return __isa(o, "SendUsersMessageRequest");
    }
    SendUsersMessageRequest.isa = isa;
})(SendUsersMessageRequest || (SendUsersMessageRequest = {}));
export var SendUsersMessageResponse;
(function (SendUsersMessageResponse) {
    function isa(o) {
        return __isa(o, "SendUsersMessageResponse");
    }
    SendUsersMessageResponse.isa = isa;
})(SendUsersMessageResponse || (SendUsersMessageResponse = {}));
export var SendUsersMessagesRequest;
(function (SendUsersMessagesRequest) {
    function isa(o) {
        return __isa(o, "SendUsersMessagesRequest");
    }
    SendUsersMessagesRequest.isa = isa;
})(SendUsersMessagesRequest || (SendUsersMessagesRequest = {}));
export var SendUsersMessagesResponse;
(function (SendUsersMessagesResponse) {
    function isa(o) {
        return __isa(o, "SendUsersMessagesResponse");
    }
    SendUsersMessagesResponse.isa = isa;
})(SendUsersMessagesResponse || (SendUsersMessagesResponse = {}));
export var Session;
(function (Session) {
    function isa(o) {
        return __isa(o, "Session");
    }
    Session.isa = isa;
})(Session || (Session = {}));
export var SetDimension;
(function (SetDimension) {
    function isa(o) {
        return __isa(o, "SetDimension");
    }
    SetDimension.isa = isa;
})(SetDimension || (SetDimension = {}));
export var SimpleCondition;
(function (SimpleCondition) {
    function isa(o) {
        return __isa(o, "SimpleCondition");
    }
    SimpleCondition.isa = isa;
})(SimpleCondition || (SimpleCondition = {}));
export var SimpleEmail;
(function (SimpleEmail) {
    function isa(o) {
        return __isa(o, "SimpleEmail");
    }
    SimpleEmail.isa = isa;
})(SimpleEmail || (SimpleEmail = {}));
export var SimpleEmailPart;
(function (SimpleEmailPart) {
    function isa(o) {
        return __isa(o, "SimpleEmailPart");
    }
    SimpleEmailPart.isa = isa;
})(SimpleEmailPart || (SimpleEmailPart = {}));
export var SourceType;
(function (SourceType) {
    SourceType["ALL"] = "ALL";
    SourceType["ANY"] = "ANY";
    SourceType["NONE"] = "NONE";
})(SourceType || (SourceType = {}));
export var StartCondition;
(function (StartCondition) {
    function isa(o) {
        return __isa(o, "StartCondition");
    }
    StartCondition.isa = isa;
})(StartCondition || (StartCondition = {}));
export var State;
(function (State) {
    State["ACTIVE"] = "ACTIVE";
    State["CANCELLED"] = "CANCELLED";
    State["CLOSED"] = "CLOSED";
    State["COMPLETED"] = "COMPLETED";
    State["DRAFT"] = "DRAFT";
})(State || (State = {}));
export var TagResourceRequest;
(function (TagResourceRequest) {
    function isa(o) {
        return __isa(o, "TagResourceRequest");
    }
    TagResourceRequest.isa = isa;
})(TagResourceRequest || (TagResourceRequest = {}));
export var TagsModel;
(function (TagsModel) {
    function isa(o) {
        return __isa(o, "TagsModel");
    }
    TagsModel.isa = isa;
})(TagsModel || (TagsModel = {}));
export var Template;
(function (Template) {
    function isa(o) {
        return __isa(o, "Template");
    }
    Template.isa = isa;
})(Template || (Template = {}));
export var TemplateActiveVersionRequest;
(function (TemplateActiveVersionRequest) {
    function isa(o) {
        return __isa(o, "TemplateActiveVersionRequest");
    }
    TemplateActiveVersionRequest.isa = isa;
})(TemplateActiveVersionRequest || (TemplateActiveVersionRequest = {}));
export var TemplateConfiguration;
(function (TemplateConfiguration) {
    function isa(o) {
        return __isa(o, "TemplateConfiguration");
    }
    TemplateConfiguration.isa = isa;
})(TemplateConfiguration || (TemplateConfiguration = {}));
export var TemplateResponse;
(function (TemplateResponse) {
    function isa(o) {
        return __isa(o, "TemplateResponse");
    }
    TemplateResponse.isa = isa;
})(TemplateResponse || (TemplateResponse = {}));
export var TemplateType;
(function (TemplateType) {
    TemplateType["EMAIL"] = "EMAIL";
    TemplateType["PUSH"] = "PUSH";
    TemplateType["SMS"] = "SMS";
    TemplateType["VOICE"] = "VOICE";
})(TemplateType || (TemplateType = {}));
export var TemplateVersionResponse;
(function (TemplateVersionResponse) {
    function isa(o) {
        return __isa(o, "TemplateVersionResponse");
    }
    TemplateVersionResponse.isa = isa;
})(TemplateVersionResponse || (TemplateVersionResponse = {}));
export var TemplateVersionsResponse;
(function (TemplateVersionsResponse) {
    function isa(o) {
        return __isa(o, "TemplateVersionsResponse");
    }
    TemplateVersionsResponse.isa = isa;
})(TemplateVersionsResponse || (TemplateVersionsResponse = {}));
export var TemplatesResponse;
(function (TemplatesResponse) {
    function isa(o) {
        return __isa(o, "TemplatesResponse");
    }
    TemplatesResponse.isa = isa;
})(TemplatesResponse || (TemplatesResponse = {}));
export var TooManyRequestsException;
(function (TooManyRequestsException) {
    function isa(o) {
        return __isa(o, "TooManyRequestsException");
    }
    TooManyRequestsException.isa = isa;
})(TooManyRequestsException || (TooManyRequestsException = {}));
export var TreatmentResource;
(function (TreatmentResource) {
    function isa(o) {
        return __isa(o, "TreatmentResource");
    }
    TreatmentResource.isa = isa;
})(TreatmentResource || (TreatmentResource = {}));
export var Type;
(function (Type) {
    Type["ALL"] = "ALL";
    Type["ANY"] = "ANY";
    Type["NONE"] = "NONE";
})(Type || (Type = {}));
export var UntagResourceRequest;
(function (UntagResourceRequest) {
    function isa(o) {
        return __isa(o, "UntagResourceRequest");
    }
    UntagResourceRequest.isa = isa;
})(UntagResourceRequest || (UntagResourceRequest = {}));
export var UpdateAdmChannelRequest;
(function (UpdateAdmChannelRequest) {
    function isa(o) {
        return __isa(o, "UpdateAdmChannelRequest");
    }
    UpdateAdmChannelRequest.isa = isa;
})(UpdateAdmChannelRequest || (UpdateAdmChannelRequest = {}));
export var UpdateAdmChannelResponse;
(function (UpdateAdmChannelResponse) {
    function isa(o) {
        return __isa(o, "UpdateAdmChannelResponse");
    }
    UpdateAdmChannelResponse.isa = isa;
})(UpdateAdmChannelResponse || (UpdateAdmChannelResponse = {}));
export var UpdateApnsChannelRequest;
(function (UpdateApnsChannelRequest) {
    function isa(o) {
        return __isa(o, "UpdateApnsChannelRequest");
    }
    UpdateApnsChannelRequest.isa = isa;
})(UpdateApnsChannelRequest || (UpdateApnsChannelRequest = {}));
export var UpdateApnsChannelResponse;
(function (UpdateApnsChannelResponse) {
    function isa(o) {
        return __isa(o, "UpdateApnsChannelResponse");
    }
    UpdateApnsChannelResponse.isa = isa;
})(UpdateApnsChannelResponse || (UpdateApnsChannelResponse = {}));
export var UpdateApnsSandboxChannelRequest;
(function (UpdateApnsSandboxChannelRequest) {
    function isa(o) {
        return __isa(o, "UpdateApnsSandboxChannelRequest");
    }
    UpdateApnsSandboxChannelRequest.isa = isa;
})(UpdateApnsSandboxChannelRequest || (UpdateApnsSandboxChannelRequest = {}));
export var UpdateApnsSandboxChannelResponse;
(function (UpdateApnsSandboxChannelResponse) {
    function isa(o) {
        return __isa(o, "UpdateApnsSandboxChannelResponse");
    }
    UpdateApnsSandboxChannelResponse.isa = isa;
})(UpdateApnsSandboxChannelResponse || (UpdateApnsSandboxChannelResponse = {}));
export var UpdateApnsVoipChannelRequest;
(function (UpdateApnsVoipChannelRequest) {
    function isa(o) {
        return __isa(o, "UpdateApnsVoipChannelRequest");
    }
    UpdateApnsVoipChannelRequest.isa = isa;
})(UpdateApnsVoipChannelRequest || (UpdateApnsVoipChannelRequest = {}));
export var UpdateApnsVoipChannelResponse;
(function (UpdateApnsVoipChannelResponse) {
    function isa(o) {
        return __isa(o, "UpdateApnsVoipChannelResponse");
    }
    UpdateApnsVoipChannelResponse.isa = isa;
})(UpdateApnsVoipChannelResponse || (UpdateApnsVoipChannelResponse = {}));
export var UpdateApnsVoipSandboxChannelRequest;
(function (UpdateApnsVoipSandboxChannelRequest) {
    function isa(o) {
        return __isa(o, "UpdateApnsVoipSandboxChannelRequest");
    }
    UpdateApnsVoipSandboxChannelRequest.isa = isa;
})(UpdateApnsVoipSandboxChannelRequest || (UpdateApnsVoipSandboxChannelRequest = {}));
export var UpdateApnsVoipSandboxChannelResponse;
(function (UpdateApnsVoipSandboxChannelResponse) {
    function isa(o) {
        return __isa(o, "UpdateApnsVoipSandboxChannelResponse");
    }
    UpdateApnsVoipSandboxChannelResponse.isa = isa;
})(UpdateApnsVoipSandboxChannelResponse || (UpdateApnsVoipSandboxChannelResponse = {}));
export var UpdateApplicationSettingsRequest;
(function (UpdateApplicationSettingsRequest) {
    function isa(o) {
        return __isa(o, "UpdateApplicationSettingsRequest");
    }
    UpdateApplicationSettingsRequest.isa = isa;
})(UpdateApplicationSettingsRequest || (UpdateApplicationSettingsRequest = {}));
export var UpdateApplicationSettingsResponse;
(function (UpdateApplicationSettingsResponse) {
    function isa(o) {
        return __isa(o, "UpdateApplicationSettingsResponse");
    }
    UpdateApplicationSettingsResponse.isa = isa;
})(UpdateApplicationSettingsResponse || (UpdateApplicationSettingsResponse = {}));
export var UpdateAttributesRequest;
(function (UpdateAttributesRequest) {
    function isa(o) {
        return __isa(o, "UpdateAttributesRequest");
    }
    UpdateAttributesRequest.isa = isa;
})(UpdateAttributesRequest || (UpdateAttributesRequest = {}));
export var UpdateBaiduChannelRequest;
(function (UpdateBaiduChannelRequest) {
    function isa(o) {
        return __isa(o, "UpdateBaiduChannelRequest");
    }
    UpdateBaiduChannelRequest.isa = isa;
})(UpdateBaiduChannelRequest || (UpdateBaiduChannelRequest = {}));
export var UpdateBaiduChannelResponse;
(function (UpdateBaiduChannelResponse) {
    function isa(o) {
        return __isa(o, "UpdateBaiduChannelResponse");
    }
    UpdateBaiduChannelResponse.isa = isa;
})(UpdateBaiduChannelResponse || (UpdateBaiduChannelResponse = {}));
export var UpdateCampaignRequest;
(function (UpdateCampaignRequest) {
    function isa(o) {
        return __isa(o, "UpdateCampaignRequest");
    }
    UpdateCampaignRequest.isa = isa;
})(UpdateCampaignRequest || (UpdateCampaignRequest = {}));
export var UpdateCampaignResponse;
(function (UpdateCampaignResponse) {
    function isa(o) {
        return __isa(o, "UpdateCampaignResponse");
    }
    UpdateCampaignResponse.isa = isa;
})(UpdateCampaignResponse || (UpdateCampaignResponse = {}));
export var UpdateEmailChannelRequest;
(function (UpdateEmailChannelRequest) {
    function isa(o) {
        return __isa(o, "UpdateEmailChannelRequest");
    }
    UpdateEmailChannelRequest.isa = isa;
})(UpdateEmailChannelRequest || (UpdateEmailChannelRequest = {}));
export var UpdateEmailChannelResponse;
(function (UpdateEmailChannelResponse) {
    function isa(o) {
        return __isa(o, "UpdateEmailChannelResponse");
    }
    UpdateEmailChannelResponse.isa = isa;
})(UpdateEmailChannelResponse || (UpdateEmailChannelResponse = {}));
export var UpdateEmailTemplateRequest;
(function (UpdateEmailTemplateRequest) {
    function isa(o) {
        return __isa(o, "UpdateEmailTemplateRequest");
    }
    UpdateEmailTemplateRequest.isa = isa;
})(UpdateEmailTemplateRequest || (UpdateEmailTemplateRequest = {}));
export var UpdateEmailTemplateResponse;
(function (UpdateEmailTemplateResponse) {
    function isa(o) {
        return __isa(o, "UpdateEmailTemplateResponse");
    }
    UpdateEmailTemplateResponse.isa = isa;
})(UpdateEmailTemplateResponse || (UpdateEmailTemplateResponse = {}));
export var UpdateEndpointRequest;
(function (UpdateEndpointRequest) {
    function isa(o) {
        return __isa(o, "UpdateEndpointRequest");
    }
    UpdateEndpointRequest.isa = isa;
})(UpdateEndpointRequest || (UpdateEndpointRequest = {}));
export var UpdateEndpointResponse;
(function (UpdateEndpointResponse) {
    function isa(o) {
        return __isa(o, "UpdateEndpointResponse");
    }
    UpdateEndpointResponse.isa = isa;
})(UpdateEndpointResponse || (UpdateEndpointResponse = {}));
export var UpdateEndpointsBatchRequest;
(function (UpdateEndpointsBatchRequest) {
    function isa(o) {
        return __isa(o, "UpdateEndpointsBatchRequest");
    }
    UpdateEndpointsBatchRequest.isa = isa;
})(UpdateEndpointsBatchRequest || (UpdateEndpointsBatchRequest = {}));
export var UpdateEndpointsBatchResponse;
(function (UpdateEndpointsBatchResponse) {
    function isa(o) {
        return __isa(o, "UpdateEndpointsBatchResponse");
    }
    UpdateEndpointsBatchResponse.isa = isa;
})(UpdateEndpointsBatchResponse || (UpdateEndpointsBatchResponse = {}));
export var UpdateGcmChannelRequest;
(function (UpdateGcmChannelRequest) {
    function isa(o) {
        return __isa(o, "UpdateGcmChannelRequest");
    }
    UpdateGcmChannelRequest.isa = isa;
})(UpdateGcmChannelRequest || (UpdateGcmChannelRequest = {}));
export var UpdateGcmChannelResponse;
(function (UpdateGcmChannelResponse) {
    function isa(o) {
        return __isa(o, "UpdateGcmChannelResponse");
    }
    UpdateGcmChannelResponse.isa = isa;
})(UpdateGcmChannelResponse || (UpdateGcmChannelResponse = {}));
export var UpdateJourneyRequest;
(function (UpdateJourneyRequest) {
    function isa(o) {
        return __isa(o, "UpdateJourneyRequest");
    }
    UpdateJourneyRequest.isa = isa;
})(UpdateJourneyRequest || (UpdateJourneyRequest = {}));
export var UpdateJourneyResponse;
(function (UpdateJourneyResponse) {
    function isa(o) {
        return __isa(o, "UpdateJourneyResponse");
    }
    UpdateJourneyResponse.isa = isa;
})(UpdateJourneyResponse || (UpdateJourneyResponse = {}));
export var UpdateJourneyStateRequest;
(function (UpdateJourneyStateRequest) {
    function isa(o) {
        return __isa(o, "UpdateJourneyStateRequest");
    }
    UpdateJourneyStateRequest.isa = isa;
})(UpdateJourneyStateRequest || (UpdateJourneyStateRequest = {}));
export var UpdateJourneyStateResponse;
(function (UpdateJourneyStateResponse) {
    function isa(o) {
        return __isa(o, "UpdateJourneyStateResponse");
    }
    UpdateJourneyStateResponse.isa = isa;
})(UpdateJourneyStateResponse || (UpdateJourneyStateResponse = {}));
export var UpdatePushTemplateRequest;
(function (UpdatePushTemplateRequest) {
    function isa(o) {
        return __isa(o, "UpdatePushTemplateRequest");
    }
    UpdatePushTemplateRequest.isa = isa;
})(UpdatePushTemplateRequest || (UpdatePushTemplateRequest = {}));
export var UpdatePushTemplateResponse;
(function (UpdatePushTemplateResponse) {
    function isa(o) {
        return __isa(o, "UpdatePushTemplateResponse");
    }
    UpdatePushTemplateResponse.isa = isa;
})(UpdatePushTemplateResponse || (UpdatePushTemplateResponse = {}));
export var UpdateSegmentRequest;
(function (UpdateSegmentRequest) {
    function isa(o) {
        return __isa(o, "UpdateSegmentRequest");
    }
    UpdateSegmentRequest.isa = isa;
})(UpdateSegmentRequest || (UpdateSegmentRequest = {}));
export var UpdateSegmentResponse;
(function (UpdateSegmentResponse) {
    function isa(o) {
        return __isa(o, "UpdateSegmentResponse");
    }
    UpdateSegmentResponse.isa = isa;
})(UpdateSegmentResponse || (UpdateSegmentResponse = {}));
export var UpdateSmsChannelRequest;
(function (UpdateSmsChannelRequest) {
    function isa(o) {
        return __isa(o, "UpdateSmsChannelRequest");
    }
    UpdateSmsChannelRequest.isa = isa;
})(UpdateSmsChannelRequest || (UpdateSmsChannelRequest = {}));
export var UpdateSmsChannelResponse;
(function (UpdateSmsChannelResponse) {
    function isa(o) {
        return __isa(o, "UpdateSmsChannelResponse");
    }
    UpdateSmsChannelResponse.isa = isa;
})(UpdateSmsChannelResponse || (UpdateSmsChannelResponse = {}));
export var UpdateSmsTemplateRequest;
(function (UpdateSmsTemplateRequest) {
    function isa(o) {
        return __isa(o, "UpdateSmsTemplateRequest");
    }
    UpdateSmsTemplateRequest.isa = isa;
})(UpdateSmsTemplateRequest || (UpdateSmsTemplateRequest = {}));
export var UpdateSmsTemplateResponse;
(function (UpdateSmsTemplateResponse) {
    function isa(o) {
        return __isa(o, "UpdateSmsTemplateResponse");
    }
    UpdateSmsTemplateResponse.isa = isa;
})(UpdateSmsTemplateResponse || (UpdateSmsTemplateResponse = {}));
export var UpdateTemplateActiveVersionRequest;
(function (UpdateTemplateActiveVersionRequest) {
    function isa(o) {
        return __isa(o, "UpdateTemplateActiveVersionRequest");
    }
    UpdateTemplateActiveVersionRequest.isa = isa;
})(UpdateTemplateActiveVersionRequest || (UpdateTemplateActiveVersionRequest = {}));
export var UpdateTemplateActiveVersionResponse;
(function (UpdateTemplateActiveVersionResponse) {
    function isa(o) {
        return __isa(o, "UpdateTemplateActiveVersionResponse");
    }
    UpdateTemplateActiveVersionResponse.isa = isa;
})(UpdateTemplateActiveVersionResponse || (UpdateTemplateActiveVersionResponse = {}));
export var UpdateVoiceChannelRequest;
(function (UpdateVoiceChannelRequest) {
    function isa(o) {
        return __isa(o, "UpdateVoiceChannelRequest");
    }
    UpdateVoiceChannelRequest.isa = isa;
})(UpdateVoiceChannelRequest || (UpdateVoiceChannelRequest = {}));
export var UpdateVoiceChannelResponse;
(function (UpdateVoiceChannelResponse) {
    function isa(o) {
        return __isa(o, "UpdateVoiceChannelResponse");
    }
    UpdateVoiceChannelResponse.isa = isa;
})(UpdateVoiceChannelResponse || (UpdateVoiceChannelResponse = {}));
export var UpdateVoiceTemplateRequest;
(function (UpdateVoiceTemplateRequest) {
    function isa(o) {
        return __isa(o, "UpdateVoiceTemplateRequest");
    }
    UpdateVoiceTemplateRequest.isa = isa;
})(UpdateVoiceTemplateRequest || (UpdateVoiceTemplateRequest = {}));
export var UpdateVoiceTemplateResponse;
(function (UpdateVoiceTemplateResponse) {
    function isa(o) {
        return __isa(o, "UpdateVoiceTemplateResponse");
    }
    UpdateVoiceTemplateResponse.isa = isa;
})(UpdateVoiceTemplateResponse || (UpdateVoiceTemplateResponse = {}));
export var VoiceChannelRequest;
(function (VoiceChannelRequest) {
    function isa(o) {
        return __isa(o, "VoiceChannelRequest");
    }
    VoiceChannelRequest.isa = isa;
})(VoiceChannelRequest || (VoiceChannelRequest = {}));
export var VoiceChannelResponse;
(function (VoiceChannelResponse) {
    function isa(o) {
        return __isa(o, "VoiceChannelResponse");
    }
    VoiceChannelResponse.isa = isa;
})(VoiceChannelResponse || (VoiceChannelResponse = {}));
export var VoiceMessage;
(function (VoiceMessage) {
    function isa(o) {
        return __isa(o, "VoiceMessage");
    }
    VoiceMessage.isa = isa;
})(VoiceMessage || (VoiceMessage = {}));
export var VoiceTemplateRequest;
(function (VoiceTemplateRequest) {
    function isa(o) {
        return __isa(o, "VoiceTemplateRequest");
    }
    VoiceTemplateRequest.isa = isa;
})(VoiceTemplateRequest || (VoiceTemplateRequest = {}));
export var VoiceTemplateResponse;
(function (VoiceTemplateResponse) {
    function isa(o) {
        return __isa(o, "VoiceTemplateResponse");
    }
    VoiceTemplateResponse.isa = isa;
})(VoiceTemplateResponse || (VoiceTemplateResponse = {}));
export var WaitActivity;
(function (WaitActivity) {
    function isa(o) {
        return __isa(o, "WaitActivity");
    }
    WaitActivity.isa = isa;
})(WaitActivity || (WaitActivity = {}));
export var WaitTime;
(function (WaitTime) {
    function isa(o) {
        return __isa(o, "WaitTime");
    }
    WaitTime.isa = isa;
})(WaitTime || (WaitTime = {}));
export var WriteApplicationSettingsRequest;
(function (WriteApplicationSettingsRequest) {
    function isa(o) {
        return __isa(o, "WriteApplicationSettingsRequest");
    }
    WriteApplicationSettingsRequest.isa = isa;
})(WriteApplicationSettingsRequest || (WriteApplicationSettingsRequest = {}));
export var WriteCampaignRequest;
(function (WriteCampaignRequest) {
    function isa(o) {
        return __isa(o, "WriteCampaignRequest");
    }
    WriteCampaignRequest.isa = isa;
})(WriteCampaignRequest || (WriteCampaignRequest = {}));
export var WriteEventStream;
(function (WriteEventStream) {
    function isa(o) {
        return __isa(o, "WriteEventStream");
    }
    WriteEventStream.isa = isa;
})(WriteEventStream || (WriteEventStream = {}));
export var WriteJourneyRequest;
(function (WriteJourneyRequest) {
    function isa(o) {
        return __isa(o, "WriteJourneyRequest");
    }
    WriteJourneyRequest.isa = isa;
})(WriteJourneyRequest || (WriteJourneyRequest = {}));
export var WriteSegmentRequest;
(function (WriteSegmentRequest) {
    function isa(o) {
        return __isa(o, "WriteSegmentRequest");
    }
    WriteSegmentRequest.isa = isa;
})(WriteSegmentRequest || (WriteSegmentRequest = {}));
export var WriteTreatmentResource;
(function (WriteTreatmentResource) {
    function isa(o) {
        return __isa(o, "WriteTreatmentResource");
    }
    WriteTreatmentResource.isa = isa;
})(WriteTreatmentResource || (WriteTreatmentResource = {}));
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@aws-sdk/client-pinpoint/dist/es/models/index.js
// module id = null
// module chunks = 